import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router'
import { Dropdown, Modal } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from 'react-select'

import ModalCreateUpdate from 'pages/admin/pos/ModalCreateUpdate'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'
import TableDropdown from 'helpers/TableDropdown'
import ModalPosChequeStats from 'pages/parts/ModalPosChequeStats'
import ModalPosTelegramStats from 'pages/parts/ModalPosTelegramStats'
import ModalPosTelegramLink from 'pages/parts/ModalPosTelegramLink'
import ModalPosVersions from 'pages/admin/pos/ModalPosVersions'
import ModalPosActivityFunnel from 'pages/admin/pos/ModalPosActivityFunnel'
import ModalPosStatusSummary from 'pages/admin/pos/ModalPosStatusSummary'
import PosStatusToggles, { POS_STATUSES, togglePosStatus } from 'pages/parts/PosStatusToggles'

import { formatDate, formatMoney, formatMoneyInput, isDateActive, returnSign } from 'helpers/helpers'
import { httpOk, GET, POST, PUT, DELETE, FILE_D } from 'helpers/api'
import { hasPermission } from 'helpers/permissions'
import { SET_ACCOUNT } from 'store/account/action'
import { store } from 'store/index'
import { parseProductTableOrderBy, buildProductTableOrderBy } from 'helpers/productFilterParams'
import { renderSortIndicator } from 'helpers/tableSortIndicator'

const TRUST_GRANT_MAX_DAYS = 25
const FREE_UNTIL_MAX_MONTHS = 3
const EMPTY_RECALC_FORM = {
	charge_id: null,
	new_amount: '',
	service_ids: [],
	transfer_to_pos_id: null,
	transfer_amount: '',
	reason: '',
}

const SELECT_PORTAL_PROPS = {
	menuPosition: 'fixed',
	menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
	menuPlacement: 'auto',
	styles: { menuPortal: (base) => ({ ...base, zIndex: 9999 }) },
}

function Index() {
	const { t } = useTranslation()
	const navigate = useNavigate()

	function getTodayDate() {
		const d = new Date()
		d.setHours(0, 0, 0, 0)
		return d
	}

	function getFreeUntilMinDate() {
		return getTodayDate()
	}

	function getFreeUntilMaxDate() {
		const d = getTodayDate()
		d.setMonth(d.getMonth() + FREE_UNTIL_MAX_MONTHS)
		return d
	}

	function getTrustMinDate() {
		const d = new Date()
		d.setHours(0, 0, 0, 0)
		if (selectedItem?.trust_granted_to) {
			const grantEnd = new Date(selectedItem.trust_granted_to)
			grantEnd.setHours(0, 0, 0, 0)
			if (grantEnd > d) {
				return grantEnd
			}
		}
		return d
	}

	function getTrustMaxDate() {
		const d = getTrustMinDate()
		d.setDate(d.getDate() + TRUST_GRANT_MAX_DAYS)
		return d
	}

	function daysFromBase(date) {
		const base = getTrustMinDate()
		const target = new Date(date)
		target.setHours(0, 0, 0, 0)
		const diff = Math.round((target - base) / 86400000)
		return Math.max(1, Math.min(TRUST_GRANT_MAX_DAYS, diff || 1))
	}

	function dateFromDays(days) {
		const n = Math.max(1, Math.min(TRUST_GRANT_MAX_DAYS, parseInt(days, 10) || 1))
		const d = getTrustMinDate()
		d.setDate(d.getDate() + n)
		return d
	}

	const statuses = POS_STATUSES

	const paymentTabs = [
		{ id: 'payment', status: 1, name: 'Оплата' },
		{ id: 'partner_bonus', status: null, name: 'Бонус агента' },
		{ id: 'minus', status: -1, name: 'Минус баланс' },
		{ id: 'annul', status: -2, name: 'Анулировать баланс' },
		{ id: 'annul_reissue', status: null, name: 'Аннул. и выставить' },
		{ id: 'annul_service', status: null, name: 'Аннулировать услугу' },
		{ id: 'recalc', status: null, name: 'Перерасчёт' },
		{ id: 'transfer', status: -3, name: 'Перевод' },
		{ id: 'free', status: null, name: 'Бесплатный период' },
		{ id: 'credit', status: null, name: 'Доверительный платеж' },
	]

	const [data, setData] = useState([])
	const [poses, setPoses] = useState([])
	const [users, setUsers] = useState([])
	const [cashiers, setCashiers] = useState([])
	const [terminals, setTerminals] = useState([])
	const [payments, setPayments] = useState([])
	const [partners, setPartners] = useState([])
	// Справочник услуг подписки — для фильтра «у кого включена услуга»
	const [filterServices, setFilterServices] = useState([])
	const [countries, setCountries] = useState([])
	const [regions, setRegions] = useState([])
	const [posPaymentTypes, setPosPaymentTypes] = useState([])
	// Полный справочник типов — для правки типа в истории оплат (helper отдаёт только ручные)
	const [allPaymentTypes, setAllPaymentTypes] = useState([])
	const [modalPaymentType, setModalPaymentType] = useState(false)
	const [selectedPaymentRow, setSelectedPaymentRow] = useState({})
	const [selectedItem, setSelectedItem] = useState({})
	const [selectedItemPartners, setSelectedItemPartners] = useState([])
	const [modalCreateUpdate, setModalCreateUpdate] = useState(false)
	const [modalPartner, setModalPartner] = useState(false)
	const [modalServices, setModalServices] = useState(false)
	const [subscriptionServicesCatalog, setSubscriptionServicesCatalog] = useState([])
	const [selectedItemServices, setSelectedItemServices] = useState([])
	const [posBilling, setPosBilling] = useState(null)
	const [openServiceCharges, setOpenServiceCharges] = useState([])
	const [recalcInfo, setRecalcInfo] = useState(null)
	const [recalcForm, setRecalcForm] = useState(EMPTY_RECALC_FORM)
	const [recalcPreview, setRecalcPreview] = useState(null)
	const [serviceForm, setServiceForm] = useState({ service_id: null, price: '' })
	const [modalPayment, setModalPayment] = useState(false)
	const [paymentTab, setPaymentTab] = useState('payment')
	const [freeUntilForm, setFreeUntilForm] = useState({ billing_free_until: '', reason: '' })
	const [creditForm, setCreditForm] = useState({ days: 1, reason: '' })
	const [posBonusPartners, setPosBonusPartners] = useState([])
	const [modalInvoice, setModalInvoice] = useState(false)
	const [modalInfo, setModalInfo] = useState(false)
	const [modalReversePayment, setModalReversePayment] = useState(false)
	const [historyPosItem, setHistoryPosItem] = useState({})
	const [reversePaymentItem, setReversePaymentItem] = useState({})
	const [reverseNote, setReverseNote] = useState('')
	const [modalStatus, setModalStatus] = useState(false)
	const statusNoteRef = useRef(null)
	const [modalBulkDelete, setModalBulkDelete] = useState(false)
	const [bulkDelete, setBulkDelete] = useState({ total: null, note: '' })
	const [modalTerminal, setModalTerminal] = useState(false)
	const [modalCreateTerminal, setModalCreateTerminal] = useState(false)
	const [modalCreateCashbox, setModalCreateCashbox] = useState(false)
	const [modalChequeStats, setModalChequeStats] = useState(false)
	const [showModalTelegram, setShowModalTelegram] = useState(false)
	const [showModalVersions, setShowModalVersions] = useState(false)
	const [showModalFunnel, setShowModalFunnel] = useState(false)
	const [showModalSummary, setShowModalSummary] = useState(false)
	const [copiedLogin, setCopiedLogin] = useState('')
	const [telegramLinkPos, setTelegramLinkPos] = useState(null)
	const [chequeStatsPos, setChequeStatsPos] = useState(null)
	const [selectedPosItem, setSelectedPosItem] = useState({})
	const [createTerminalItem, setCreateTerminalItem] = useState({})
	const [createCashboxItem, setCreateCashboxItem] = useState({})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const {
		filterData,
		setFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		applySearch,
		applyFilters,
		paginate,
		patchFilterData,
	} = useFilterSearchPagination({
		initialFilterData: {
			status_ids: [{ 'id': 1, 'name': "Активный" }],
			tariff_not_zero: true,
			search: '',
			page: null,
		},
		initialPagination: {
			url: '/admin/pos',
			response: null
		},
	})

	async function searchWithFilter(nextFilterData = filterData) {
		var filterDataCopy = { ...nextFilterData }
		var filterUrl = "/admin/pos"
		var urlParams = ""
		checkFilter(filterDataCopy)

		if (filterDataCopy.no_region)
			urlParams += returnSign(urlParams) + 'no_region=1'
		else if (filterDataCopy.region_id)
			urlParams += returnSign(urlParams) + 'region_id=' + filterDataCopy.region_id
		if (filterDataCopy.partner_id)
			urlParams += returnSign(urlParams) + 'partner_id=' + filterDataCopy.partner_id
		if (filterDataCopy.service_id)
			urlParams += returnSign(urlParams) + 'service_id=' + filterDataCopy.service_id
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.status_ids && filterDataCopy.status_ids.length > 0) {
			const ids = filterDataCopy.status_ids.map(item => item.id).join(',');
			urlParams += returnSign(urlParams) + 'status_ids=' + ids;
		}
		if (filterDataCopy.tariff_not_zero)
			urlParams += returnSign(urlParams) + 'tariff_not_zero=1'
		if (filterDataCopy.credit_only)
			urlParams += returnSign(urlParams) + 'credit_only=1'
		if (filterDataCopy.order_by)
			urlParams += returnSign(urlParams) + 'order_by=' + filterDataCopy.order_by
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		if (`/admin/pos${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}

		setDropdownIsOpen(false)
	}

	function copyLogin(login) {
		navigator.clipboard.writeText(login)
		setCopiedLogin(login)
		toast.dismiss()
		toast.success(`${login} — скопировано`)
	}

	async function downloadExcel() {
		var filterDataCopy = { ...filterData }
		var filterUrl = "/admin/pos"
		var urlParams = ""

		if (filterDataCopy.no_region)
			urlParams += returnSign(urlParams) + 'no_region=1'
		else if (filterDataCopy.region_id)
			urlParams += returnSign(urlParams) + 'region_id=' + filterDataCopy.region_id
		if (filterDataCopy.partner_id)
			urlParams += returnSign(urlParams) + 'partner_id=' + filterDataCopy.partner_id
		if (filterDataCopy.service_id)
			urlParams += returnSign(urlParams) + 'service_id=' + filterDataCopy.service_id
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.status_ids && filterDataCopy.status_ids.length > 0) {
			const ids = filterDataCopy.status_ids.map(item => item.id).join(',')
			urlParams += returnSign(urlParams) + 'status_ids=' + ids
		}
		if (filterDataCopy.tariff_not_zero)
			urlParams += returnSign(urlParams) + 'tariff_not_zero=1'
		if (filterDataCopy.credit_only)
			urlParams += returnSign(urlParams) + 'credit_only=1'
		if (filterDataCopy.order_by)
			urlParams += returnSign(urlParams) + 'order_by=' + filterDataCopy.order_by

		urlParams += returnSign(urlParams) + 'excel=true'

		const response = await FILE_D(filterUrl + urlParams)
		if (httpOk(response)) {
			const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
			const fileUrl = URL.createObjectURL(file)
			const link = document.createElement('a')
			link.href = fileUrl
			link.setAttribute('download', 'admin-poses.xlsx')
			document.body.appendChild(link)
			link.click()
			URL.revokeObjectURL(fileUrl)
		}
	}

	async function createUpdate(e) {
		e.preventDefault();

		var response
		if (!selectedItem.id) {
			response = await POST('/admin/pos', selectedItem, { loader: true })
		} else {
			response = await PUT('/admin/pos', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			setSelectedItem({})
			toggleModalCreateUpdate()
		}
	}

	async function payment(e) {
		e.preventDefault();

		var response
		if (paymentTab === 'partner_bonus') {
			if (!selectedItem.partner_login) {
				return
			}
			response = await POST(`/admin/pos/${selectedItem.id}/billing/pay-partner-bonus`, {
				partner_login: selectedItem.partner_login,
				amount: selectedItem.amount,
				note: (selectedItem.note && String(selectedItem.note).trim()) || 'Оплата с бонуса агента',
			}, { loader: true })
		} else if (paymentTab === 'annul_reissue') {
			response = await POST(`/admin/pos/${selectedItem.id}/billing/annul-and-recharge`, {
				reason: (selectedItem.note && String(selectedItem.note).trim()) || 'Аннуляция и перевыставление',
				is_charge_tariff: selectedItem.is_charge_tariff !== false,
				is_charge_services: selectedItem.is_charge_services !== false,
			}, { loader: true })
		} else if (paymentTab === 'annul' || selectedItem.status === -2) {
			response = await POST(`/admin/pos/${selectedItem.id}/billing/annul-debt`, {
				reason: (selectedItem.note && String(selectedItem.note).trim()) || 'Анулирование баланса',
				is_current_period_only: true,
			}, { loader: true })
		} else {
			response = await POST('/admin/pos-payment', selectedItem, { loader: true })
		}
		if (httpOk(response)) {
			setSelectedItem({})
			setPosBonusPartners([])
			setModalPayment(false)
			getPartners()
			searchWithFilter()
		}
	}

	async function loadPartnerBonusDefaults(posId) {
		const response = await GET(`/admin/pos/${posId}/partners`, {})
		if (!httpOk(response)) {
			setPosBonusPartners([])
			return
		}
		const linked = (response.data || [])
			.filter((item) => item.login)
			.map((item) => ({
				id: item.partner_id,
				login: item.login,
				name: item.name,
				balance: item.balance,
			}))
		setPosBonusPartners(linked)
		const firstLogin = linked[0]?.login
		if (!firstLogin) {
			return
		}
		setSelectedItem((prev) => ({
			...prev,
			partner_login: prev.partner_login && linked.some((p) => p.login === prev.partner_login)
				? prev.partner_login
				: firstLogin,
		}))
	}

	async function loadFreeUntilForPos(item) {
		let until = item.billing_free_until ? String(item.billing_free_until).slice(0, 10) : ''
		const billingResponse = await GET(`/admin/pos/${item.id}/billing`, {})
		if (httpOk(billingResponse) && billingResponse.data?.pos) {
			const apiUntil = billingResponse.data.pos.billing_free_until
			until = apiUntil ? String(apiUntil).slice(0, 10) : ''
		}
		setFreeUntilForm({ billing_free_until: until, reason: '' })
	}

	function selectPaymentTab(tab) {
		setPaymentTab(tab.id)
		if (tab.status != null) {
			setSelectedItem({ ...selectedItem, status: tab.status })
		}
		if (tab.id === 'partner_bonus' && selectedItem?.id) {
			loadPartnerBonusDefaults(selectedItem.id)
		}
		if (tab.id === 'annul_service' && selectedItem?.id) {
			loadOpenServiceCharges(selectedItem.id)
		}
		if (tab.id === 'recalc' && selectedItem?.id) {
			loadRecalcInfo(selectedItem.id)
		}
	}

	async function loadRecalcInfo(posId) {
		setRecalcForm(EMPTY_RECALC_FORM)
		setRecalcPreview(null)
		const response = await GET(`/admin/pos/${posId}/billing/recalc`, {}, { loader: true })
		setRecalcInfo(httpOk(response) ? response.data : null)
	}

	// Любая правка формы сбрасывает прогон: провести можно только то, что только что проверили
	function changeRecalcForm(patch) {
		setRecalcForm((prev) => ({ ...prev, ...patch }))
		setRecalcPreview(null)
	}

	function toggleRecalcService(serviceId) {
		const ids = recalcForm.service_ids.includes(serviceId)
			? recalcForm.service_ids.filter((id) => id !== serviceId)
			: [...recalcForm.service_ids, serviceId]
		changeRecalcForm({ service_ids: ids })
	}

	function recalcPayload(isPreview) {
		const payload = {
			reason: String(recalcForm.reason || '').trim(),
			service_ids: recalcForm.service_ids,
			is_preview: isPreview,
		}
		if (recalcForm.charge_id) {
			payload.charge_id = recalcForm.charge_id
			payload.new_amount = recalcForm.new_amount
		}
		if (recalcForm.transfer_to_pos_id) {
			payload.transfer_to_pos_id = recalcForm.transfer_to_pos_id
			payload.transfer_amount = recalcForm.transfer_amount
		}
		return payload
	}

	async function previewRecalc() {
		const response = await POST(`/admin/pos/${selectedItem.id}/billing/recalc`, recalcPayload(true), { loader: true, notification: false })
		if (httpOk(response)) setRecalcPreview(response.data?.data || null)
	}

	async function applyRecalc() {
		if (!recalcPreview) return
		if (!window.confirm('Провести перерасчёт? Балансы точек и бонусы агентов изменятся так, как показано в проверке.')) return
		const response = await POST(`/admin/pos/${selectedItem.id}/billing/recalc`, recalcPayload(false), { loader: true })
		if (httpOk(response)) {
			setRecalcInfo(null)
			setRecalcForm(EMPTY_RECALC_FORM)
			setRecalcPreview(null)
			setModalPayment(false)
			searchWithFilter()
		}
	}

	function recalcChargeLabel(charge) {
		const period = charge.period_start
			? formatDate(charge.period_start)
			: `${String(charge.billing_cycle_month).padStart(2, '0')}.${charge.billing_cycle_year}`
		const name = Number(charge.charge_kind_id) === 1
			? 'Абонентская плата'
			: (charge.service_name || `Услуга #${charge.service_id}`)
		return `${period} — ${name}`
	}

	function recalcBonusTotals(bonuses = []) {
		const totals = {}
		bonuses.forEach((row) => {
			totals[row.login] = (totals[row.login] || 0) + Number(row.partner_amount || 0)
		})
		return Object.entries(totals)
	}

	async function saveFreeUntil(e) {
		e.preventDefault()
		if (!freeUntilForm.billing_free_until) {
			return
		}
		const response = await POST(`/admin/pos/${selectedItem.id}/billing/free-until`, {
			billing_free_until: freeUntilForm.billing_free_until,
			reason: freeUntilForm.reason || null,
			is_cancel_open_charges: true,
		}, { loader: true })
		if (httpOk(response)) {
			setModalPayment(false)
			setFreeUntilForm({ billing_free_until: '', reason: '' })
			searchWithFilter()
		}
	}

	async function clearFreeUntil() {
		const response = await POST(`/admin/pos/${selectedItem.id}/billing/free-until`, {
			billing_free_until: null,
			reason: freeUntilForm.reason || null,
			is_cancel_open_charges: false,
		}, { loader: true })
		if (httpOk(response)) {
			setModalPayment(false)
			setFreeUntilForm({ billing_free_until: '', reason: '' })
			searchWithFilter()
		}
	}

	async function saveCredit(e) {
		e.preventDefault()
		const days = Math.max(1, Math.min(TRUST_GRANT_MAX_DAYS, parseInt(creditForm.days, 10) || 1))
		const response = await POST(`/admin/pos/${selectedItem.id}/billing/grants`, {
			days,
			reason: (creditForm.reason && String(creditForm.reason).trim()) || 'Доверительный платеж',
		}, { loader: true })
		if (httpOk(response)) {
			setModalPayment(false)
			setCreditForm({ days: 1, reason: '' })
			searchWithFilter()
		}
	}

	async function createPosPartner(e) {
		e.preventDefault();

		var response = await POST(`/admin/pos/${selectedItem.id}/partner`, selectedItem, { loader: true })

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalPartner()
		}
	}

	async function updatePosPartner(item) {
		var response = await PUT(`/admin/pos/${selectedItem.id}/partner`, item, { loader: true })

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalPartner()
		}
	}

	async function deletePosPartner(item) {
		var response = await DELETE(`/admin/pos/${item.id}/partner`, {}, { loader: true })

		if (httpOk(response)) toggleModalPartner()
	}

	function handleChangePartner(option, index) {
		var selectedItemPartnersCopy = [...selectedItemPartners]
		selectedItemPartnersCopy[index]['partner_id'] = option.id

		setSelectedItemPartners(selectedItemPartnersCopy)
	}

	function handleChangePartnerPercentage(value, index) {
		var selectedItemPartnersCopy = [...selectedItemPartners]
		selectedItemPartnersCopy[index]['partner_percentage'] = value
		setSelectedItemPartners(selectedItemPartnersCopy)
	}

	async function createInvoice(e) {
		e.preventDefault();

		var sendData = {}

		sendData.id = selectedItem.id
		sendData.pos_payment_type_id = 1
		sendData.amount = selectedItem.amount
		sendData.phone = `998${selectedItem.invoice_phone}`

		const response = await POST('/payment/pos-invoice', sendData)
		if (httpOk(response)) setModalInvoice(false)
	}

	function toggleModalUpdate(item) {
		var selectedItemCopy = { ...item }
		setSelectedItem(selectedItemCopy)
		setModalCreateUpdate(true)
	}

	function toggleModalPayment(item, tabId = 'payment') {
		if (!poses.length) getPoses()
		if (!posPaymentTypes.length) getPosPaymentTypes()
		if (!partners.length) getPartners()

		var selectedItemCopy = { ...item }
		selectedItemCopy.payment = ""
		selectedItemCopy.note = ""
		const tab = paymentTabs.find((t) => t.id === tabId) || paymentTabs[0]
		selectedItemCopy.status = tab.status != null ? tab.status : 1
		selectedItemCopy.to_pos_id = ''
		selectedItemCopy.partner_login = ''
		const balanceNum = Number(item.balance) || 0
		const monthlyTotal = Number(item.monthly_total ?? item.tariff) || 0
		selectedItemCopy.amount = balanceNum < 0 ? Math.abs(balanceNum) : monthlyTotal
		selectedItemCopy.pos_payment_type_id = 4
		selectedItemCopy.is_charge_tariff = true
		selectedItemCopy.is_charge_services = true
		selectedItemCopy.monthly_total = monthlyTotal
		selectedItemCopy.services_total = Number(item.services_total) || 0

		setPaymentTab(tab.id)
		setSelectedItem(selectedItemCopy)
		setCreditForm({ days: 1, reason: '' })
		setPosBonusPartners([])
		setOpenServiceCharges([])
		setRecalcInfo(null)
		setRecalcForm(EMPTY_RECALC_FORM)
		setRecalcPreview(null)
		setModalPayment(true)
		loadFreeUntilForPos(item)
		loadOpenServiceCharges(item.id)
		if (tab.id === 'partner_bonus') {
			loadPartnerBonusDefaults(item.id)
		}
		if (tab.id === 'recalc') {
			loadRecalcInfo(item.id)
		}
	}

	async function loadOpenServiceCharges(posId) {
		const response = await GET(`/admin/pos/${posId}/billing`, {})
		if (!httpOk(response)) {
			setOpenServiceCharges([])
			return
		}
		const charges = (response.data?.charges || []).filter((charge) => {
			const status = Number(charge.status)
			const kind = Number(charge.charge_kind_id)
			return kind === 2 && (status === 1 || status === 2)
		})
		setOpenServiceCharges(charges)
		if (response.data?.pos) {
			setSelectedItem((prev) => ({
				...prev,
				balance: response.data.pos.balance,
			}))
		}
	}

	function openChargeAmount(charge) {
		const final = Number(charge.amount_final) || 0
		const allocated = Number(charge.amount_allocated) || 0
		return Math.max(0, Math.round((final - allocated) * 100) / 100)
	}

	async function annulOpenServiceCharge(charge) {
		const amount = openChargeAmount(charge)
		const label = charge.service_name || `услуга #${charge.service_id || charge.id}`
		const period = charge.billing_cycle_month && charge.billing_cycle_year
			? `${String(charge.billing_cycle_month).padStart(2, '0')}.${charge.billing_cycle_year}`
			: ''
		const ok = window.confirm(
			`Аннулировать начисление «${label}» на ${formatMoney(amount)}`
			+ (period ? ` (${period})` : '')
			+ '?\nАбонентка и остальные начисления не изменятся.'
		)
		if (!ok || !selectedItem?.id) return

		const response = await POST(`/admin/pos/${selectedItem.id}/billing/annul-charge`, {
			charge_id: charge.id,
			reason: (selectedItem.note && String(selectedItem.note).trim())
				|| `Аннуляция начисления услуги: ${label}`,
		}, { loader: true })

		if (httpOk(response)) {
			const balanceAfter = response.data?.data?.balance_after
			if (balanceAfter != null) {
				setSelectedItem((prev) => ({
					...prev,
					balance: balanceAfter,
					amount: Number(balanceAfter) < 0 ? Math.abs(Number(balanceAfter)) : prev.amount,
				}))
			}
			await loadOpenServiceCharges(selectedItem.id)
			searchWithFilter()
		}
	}

	function toggleModalInvoice(item) {
		var selectedItemCopy = { ...item }
		if (item.balance <= 0) {
			selectedItemCopy.amount = Math.abs(item.balance)
		} else {
			selectedItemCopy.amount = Number(item.monthly_total ?? item.tariff) || 0
		}
		selectedItemCopy.invoice_phone = ""

		setSelectedItem(selectedItemCopy)
		setModalInvoice(true)
	}

	// Процент партнёра — его деньги: менять доли может только тот, у кого отдельное право.
	// С одним admin_poses_partners окно открывается только для просмотра (API тоже закрыт)
	const canManagePartners = hasPermission('admin_poses_partners_manage')

	async function toggleModalPartner(bool = false, item = {}) {
		if (bool) {
			const response = await GET(`/admin/pos/${item.id}/partners`, {}, { loader: true })
			if (httpOk(response)) setSelectedItemPartners(response.data)
		}

		setSelectedItem({ 'id': item.id, 'partner_id': null, 'partner_percentage': '' })
		setModalPartner(bool)
	}

	// Бэкенд отдаёт numeric как «100000.00» — в полях показываем чистое число, без нулевых тийинов
	function normalizeServicePrice(value) {
		const num = Number(value)
		return Number.isFinite(num) ? String(num) : ''
	}

	async function loadPosServices(posId) {
		const response = await GET(`/admin/pos/${posId}/subscription-services`, {}, { loader: true })
		if (httpOk(response)) {
			setSelectedItemServices((response.data?.data || []).map((row) => {
				const price = normalizeServicePrice(row.price)
				// price_saved — что лежит в базе: по нему видно, правили ли цену в ячейке
				return { ...row, price, price_saved: price }
			}))
			// Даты абонентки приезжают в pos, кладём рядом с разбивкой тарифа
			setPosBilling({
				...(response.data?.billing || {}),
				pos_created_at: response.data?.pos?.created_at || null,
				tariff_last_charged_at: response.data?.pos?.tariff_last_charged_at || null,
			})
		}
	}

	function getActiveBillingServices(list = []) {
		const now = new Date()
		return list.filter((item) => {
			if (Number(item.status) !== 1) return false
			if (!item.ended_at) return true
			const ended = new Date(item.ended_at)
			ended.setHours(23, 59, 59, 999)
			return ended >= now
		})
	}

	async function toggleModalServices(bool = false, item = {}) {
		if (bool) {
			if (!subscriptionServicesCatalog.length) {
				const catalogResponse = await GET('/admin/subscription-services', { status: 1 })
				if (httpOk(catalogResponse)) {
					setSubscriptionServicesCatalog(catalogResponse.data?.data || [])
				}
			}
			await loadPosServices(item.id)
			setServiceForm({ service_id: null, price: '' })
			setSelectedItem({ id: item.id, tariff: item.tariff, name: item.name })
		} else {
			setSelectedItemServices([])
			setPosBilling(null)
			setServiceForm({ service_id: null, price: '' })
		}
		setModalServices(bool)
	}

	async function createPosService(e) {
		e.preventDefault()
		const response = await POST(`/admin/pos/${selectedItem.id}/subscription-service`, {
			service_id: serviceForm.service_id,
			price: String(serviceForm.price).replace(/\s/g, ''),
			status: 1,
		}, { loader: true })
		if (httpOk(response)) {
			setServiceForm({ service_id: null, price: '' })
			await loadPosServices(selectedItem.id)
		}
	}

	async function updatePosService(item) {
		const response = await PUT(`/admin/pos/${selectedItem.id}/subscription-service`, {
			id: item.id,
			price: String(item.price).replace(/\s/g, ''),
			status: item.status,
		}, { loader: true })
		if (httpOk(response)) await loadPosServices(selectedItem.id)
	}

	// Цена правится прямо в ячейке: сохраняем, когда поле потеряло фокус (или Enter), и только если число изменилось
	async function savePosServicePrice(item) {
		const price = String(item.price).replace(/\s/g, '')
		if (price === '') {
			await loadPosServices(selectedItem.id)
			return
		}
		if (price === String(item.price_saved)) return
		await updatePosService(item)
	}

	// Удаление услуги не гасит уже выставленные по ней начисления: следующая оплата
	// сначала закроет их, и на абонентку может не хватить. Поэтому спрашиваем про долг.
	async function deletePosService(item) {
		if (!window.confirm(`Отключить услугу «${item.name}» от точки?`)) return
		const openDebt = Number(item.open_debt || 0)
		let isAnnul = false
		if (openDebt > 0) {
			isAnnul = window.confirm(
				`По услуге «${item.name}» не оплачено ${formatMoney(openDebt)}.\n\n` +
				'ОК — аннулировать этот долг вместе с услугой.\n' +
				'Отмена — отключить услугу, долг оставить.'
			)
		}
		const response = await DELETE(`/admin/pos/${selectedItem.id}/subscription-service`, {
			id: item.id,
			is_annul_open_charges: isAnnul ? 1 : 0,
		}, { loader: true })
		if (httpOk(response)) await loadPosServices(selectedItem.id)
	}

	async function deferPosService(item, date) {
		let accessUntil = null
		if (date) {
			const y = date.getFullYear()
			const m = String(date.getMonth() + 1).padStart(2, '0')
			const d = String(date.getDate()).padStart(2, '0')
			accessUntil = `${y}-${m}-${d}`
		}
		const response = await POST(`/admin/pos/${selectedItem.id}/subscription-service/deferral`, {
			id: item.id,
			access_until: accessUntil,
		}, { loader: true })
		if (httpOk(response)) await loadPosServices(selectedItem.id)
	}

	function parseServiceAccessUntil(value) {
		if (!value) return null
		const date = new Date(value)
		if (Number.isNaN(date.getTime())) return null
		date.setHours(0, 0, 0, 0)
		return date
	}

	// Активная услуга ≠ доступная на кассе: платная включается только после оплаты
	// или на время отсрочки. Причину доступа считает бэкенд (access_reason).
	function getServiceAccessLabel(item) {
		switch (item.access_reason) {
			case 'free':
				return 'Бесплатно — работает на кассе'
			case 'paid':
				return 'Оплачено — работает на кассе'
			case 'deferred':
				return `Отсрочка до ${formatDate(item.access_until)} — работает на кассе`
			case 'charged_unpaid':
				return 'Начислено, но не оплачено — отключено на кассе'
			case 'scheduled':
				return `Начисление с ${formatDate(item.started_at)} — долга нет, на кассе отключена`
			default:
				return 'Не оплачено — отключено на кассе'
		}
	}

	// Заливка ячейки статуса: зелёная — работает на кассе, красная — отключена из-за неоплаты,
	// жёлтая — начисление ещё впереди (долга нет)
	function getServiceStatusClass(item) {
		if (Number(item.status) !== 1) return ''
		if (item.has_paid_access) return 'bg-success text-white'
		if (item.access_reason === 'scheduled') return 'bg-warning text-dark'
		return 'bg-danger text-white'
	}

	function getServiceDeferralMaxDate() {
		const d = getTodayDate()
		d.setDate(d.getDate() + 31)
		return d
	}

	function handleChangeServicePrice(value, index) {
		const copy = [...selectedItemServices]
		copy[index] = { ...copy[index], price: value }
		setSelectedItemServices(copy)
	}

	async function toggleModalInfo(item) {
		const response = await GET('/admin/pos-payment-detail', {
			'id': item.id,
			'login': item.login,
		}, { loader: true })

		if (httpOk(response)) {
			setHistoryPosItem(item)
			setPayments(response.data)
			setModalInfo(true)
		}
	}

	async function loadPaymentHistory(item = historyPosItem) {
		const response = await GET('/admin/pos-payment-detail', {
			'id': item.id,
			'login': item.login,
		}, { loader: true })

		if (httpOk(response)) setPayments(response.data)
	}

	function openReversePaymentModal(payment) {
		setReversePaymentItem(payment)
		setReverseNote('')
		setModalReversePayment(true)
		setModalInfo(false)
	}

	function closeReversePaymentModal(reopenHistory = true) {
		setModalReversePayment(false)
		setReversePaymentItem({})
		setReverseNote('')
		if (reopenHistory && historyPosItem?.id) {
			setModalInfo(true)
		}
	}

	async function reverseLastPayment(e) {
		e.preventDefault()
		if (!reverseNote.trim()) return

		const response = await POST(`/admin/pos-payment/${reversePaymentItem.id}/reverse`, {
			note: reverseNote.trim(),
		}, { loader: true })

		if (httpOk(response)) {
			closeReversePaymentModal(false)
			await loadPaymentHistory()
			setModalInfo(true)
			searchWithFilter()
		}
	}

	function canReversePayment(payment, index = 0) {
		if (!payment) {
			return false
		}
		if (Number(payment.status) !== 1) {
			return false
		}
		if (payment.transaction_type === 'minus' || payment.payment_type === 'transfer' || payment.payment_type === 'reverse') {
			return false
		}
		// payments DESC: новее только system-minus (абонентка/услуги после оплаты)
		for (let i = 0; i < index; i++) {
			const newer = payments[i]
			if (!(newer?.transaction_type === 'minus' && newer?.payment_type === 'system')) {
				return false
			}
		}
		return true
	}

	/**
	 * Тип оплаты правится прямо в истории заведения.
	 *
	 * Раздел «Поступления» для этого не годится: он показывает платежи всех клиентов
	 * компании разом, и открывать его сотруднику ради правки одной строки незачем.
	 * Здесь же видно только это заведение.
	 *
	 * Менять можно лишь реальные поступления — сервер того же мнения: аннуляции,
	 * сторно и системные списания он отклонит.
	 */
	function canChangePaymentType(item) {
		if (!hasPermission('admin_payments_history_update')) return false
		if (!item?.id) return false
		if (Number(item.status) !== 1) return false
		if (item.transaction_type !== 'plus') return false
		// Только платежи, заведённые вручную. Поступление от payme или rahmat —
		// факт, пришедший от платёжной системы, а не выбор оператора.
		if (item.payment_type !== 'admin') return false
		// За «Бонусом» и «Партнер бонусом» стоят списания с бонусных балансов:
		// переименование такого платежа разошлось бы с ними.
		if (item.type_is_manual === false) return false
		return true
	}

	async function openPaymentTypeModal(item) {
		if (!allPaymentTypes.length) {
			const response = await GET('/admin/pos-payment-types')
			// Предлагаем только способы, которыми деньги реально приходят в кассу
			// компании: наличные, карта, расчётный счёт. Типы платёжных систем и
			// бонусов проставляются сами и в выборе не участвуют.
			if (httpOk(response)) setAllPaymentTypes((response.data || []).filter(type => type.is_manual))
		}

		setSelectedPaymentRow({
			id: item.id,
			pos_payment_type_id: item.pos_payment_type_id,
			amount: item.amount,
			created_at: item.created_at,
		})
		setModalPaymentType(true)
	}

	async function savePaymentType() {
		if (!selectedPaymentRow.id || !selectedPaymentRow.pos_payment_type_id) return

		const response = await PUT('/admin/payment-history/payment-type', {
			id: selectedPaymentRow.id,
			pos_payment_type_id: selectedPaymentRow.pos_payment_type_id,
		}, { loader: true })

		if (httpOk(response)) {
			setModalPaymentType(false)
			loadPaymentHistory()
		}
	}

	function getPaymentTypeLabel(item) {
		if (item?.payment_type_name) return item.payment_type_name
		if (item?.payment_type === 'payme') return 'payme'
		if (item?.payment_type === 'rahmat') return 'rahmat'
		if (item?.payment_type === 'admin') return 'Админ'
		if (item?.payment_type === 'system') return 'Система'
		if (item?.payment_type === 'transfer') return 'Перевод'
		if (item?.payment_type === 'reverse') return 'Сторно'
		if (item?.payment_type === 'annul') return 'Аннулирование'
		return '—'
	}

	// Автора нет: у абонентки и онлайн-оплат это норма, у ручных операций — старые записи,
	// где автора ещё не писали
	function getPaymentAuthorFallback(item) {
		if (['system', 'payme', 'rahmat', 'uzum'].includes(item?.payment_type)) return 'Автоматически'
		return '—'
	}

	function getOperationKindLabel(item) {
		const kind = item?.operation_kind
		if (kind === 'annul') return 'Аннулирование'
		if (kind === 'balance_minus') return 'Минус баланс'
		if (kind === 'system_charge') return 'Списание системы'
		if (kind === 'reverse') return 'Сторно'
		if (kind === 'transfer') return 'Перевод'
		if (kind === 'payment') return 'Оплата'
		if (item?.transaction_type === 'minus') return 'Минус баланс'
		if (item?.transaction_type === 'plus') return 'Оплата'
		return '—'
	}

	async function handleChangeStatus(e) {
		e.preventDefault()

		// Удаление без причины не проводим — иначе в истории останется пустая строка
		if (isStatusNoteRequired && !statusNote) return

		const response = await PUT('/admin/pos/change-status', {
			'id': selectedItem.id,
			'status': selectedItem.status,
			'note': statusNote,
		}, { loader: true })

		if (!httpOk(response)) return

		searchWithFilter()
		toggleModalStatus(false)
	}

	async function toggleModalStatus(bool = false, item = {}) {
		if (bool) {
			// заблокированную или удалённую точку обычно открывают, чтобы вернуть в работу —
			// сразу подставляем «Активировать»
			const nextStatus = (item.status === -1 || item.status === -3) ? 1 : item.status
			setSelectedItem({ ...item, 'status': nextStatus, 'status_note': '' })
			setModalStatus(true)
		} else {
			setModalStatus(false)
		}
	}

	// Массовое удаление: под нож идут только отключённые точки (-1), попавшие
	// под текущие фильтры списка. Статус в запрос не передаём — его на бэкенде
	// жёстко -1, чтобы активную точку нельзя было снести пакетом.
	function bulkDeleteParams() {
		const params = {}
		if (filterData.search) params.search = filterData.search
		if (filterData.no_region) params.no_region = 1
		else if (filterData.region_id) params.region_id = filterData.region_id
		if (filterData.partner_id) params.partner_id = filterData.partner_id
		if (filterData.service_id) params.service_id = filterData.service_id
		if (filterData.tariff_not_zero) params.tariff_not_zero = 1

		return params
	}

	async function toggleModalBulkDelete(bool = false) {
		if (!bool) {
			setModalBulkDelete(false)
			return
		}

		setBulkDelete({ total: null, note: '' })
		setModalBulkDelete(true)

		const response = await GET('/admin/pos/bulk-delete-preview', bulkDeleteParams(), { loader: true })
		if (httpOk(response)) {
			setBulkDelete((prev) => ({ ...prev, 'total': response.data.total }))
		}
	}

	async function handleBulkDelete(e) {
		e.preventDefault()

		const note = (bulkDelete.note ?? '').trim()
		// причина обязательна так же, как при удалении одной точки
		if (!note || !bulkDelete.total) return

		const response = await PUT('/admin/pos/bulk-delete', { ...bulkDeleteParams(), 'note': note }, { loader: true })
		if (!httpOk(response)) return

		toast.success(`Удалено точек: ${response.data.deleted}`)
		toggleModalBulkDelete(false)
		searchWithFilter()
	}

	// история статусов живёт отдельной страницей — со строки уходим туда уже с фильтром по точке
	function openStatusHistory(item = null) {
		navigate(item ? `/admin/pos-status-history?pos_id=${item.id}` : '/admin/pos-status-history')
	}

	async function toggleModalCreateUpdate(bool = false, item = { 'tariff': '500000', 'balance': '0' }) {
		if (!users.length) getUsers()
		if (!item.id) item.type = 1
		setSelectedItem(item)
		setModalCreateUpdate(bool)
	}

	async function toggleModalTerminal(bool = false, item = {}) {

		if (bool) {
			setSelectedPosItem(item)
			const responseTerminal = await GET(`/admin/helper/terminals/${item.id}`)
			if (httpOk(responseTerminal)) setTerminals(responseTerminal.data)

			const responseCashiers = await GET(`/admin/helper/cashiers/${item.id}`)
			if (httpOk(responseCashiers)) setCashiers(responseCashiers.data)
		}

		setModalTerminal(bool)
	}

	function openCreateTerminalModal(item) {
		setSelectedPosItem(item)
		setCreateTerminalItem({
			name: '',
			password: '',
		})
		setModalCreateTerminal(true)
	}

	function openCreateCashboxModal(item) {
		setSelectedPosItem(item)
		setCreateCashboxItem({
			name: '',
			is_auto: false,
			is_default: false,
		})
		setModalCreateCashbox(true)
	}

	function openChequeStatsModal(item) {
		setChequeStatsPos(item)
		setModalChequeStats(true)
	}

	async function createTerminal(e) {
		e.preventDefault()

		const response = await POST(
			`/admin/pos/${selectedPosItem.id}/terminals`,
			createTerminalItem,
			{ loader: true }
		)

		if (httpOk(response)) {
			setModalCreateTerminal(false)
			if (modalTerminal && selectedPosItem?.id) {
				const responseTerminal = await GET(`/admin/helper/terminals/${selectedPosItem.id}`)
				if (httpOk(responseTerminal)) setTerminals(responseTerminal.data)
			}
		}
	}

	async function deleteTerminal(item) {
		if (terminals.length <= 1) return
		if (!window.confirm(`Удалить терминал «${item.name}» (${item.terminal_login})? Касса с этим логином больше не войдёт.`)) return

		const response = await DELETE(`/admin/pos/${selectedPosItem.id}/terminals/${item.id}`, {}, { loader: true })
		if (httpOk(response)) {
			setTerminals(terminals.filter(terminal => terminal.id !== item.id))
		}
	}

	async function createCashbox(e) {
		e.preventDefault()

		const response = await POST(
			`/admin/pos/${selectedPosItem.id}/cashbox`,
			createCashboxItem,
			{ loader: true }
		)

		if (httpOk(response)) {
			setModalCreateCashbox(false)
		}
	}

	function checkFilter(currentFilterData) {
		if (!currentFilterData.search && !currentFilterData.page) {
			setFilterDataExist(false)
		}
	}

	function posSortStateForIndicator(fd) {
		const { field, sort } = parseProductTableOrderBy(fd.order_by)
		return { order_by: field, sort }
	}

	function handlePosTableSort(fieldKey) {
		const { field: currentField, sort: currentSort } = parseProductTableOrderBy(filterData.order_by)
		const nextSort = currentField === fieldKey ? (currentSort === 'asc' ? 'desc' : 'asc') : 'asc'
		const order_by = buildProductTableOrderBy(fieldKey, nextSort)
		const nextFilterData = { ...filterData, order_by, page: null }
		patchFilterData({ order_by, page: null })
		searchWithFilter(nextFilterData)
	}

	function toggleDropdown(isOpen) {
		setDropdownIsOpen(!!isOpen)
	}

	// Клик по плашке статуса — включить/выключить статус в фильтре и сразу применить
	function toggleStatusFilter(id) {
		const nextFilterData = { ...filterData, status_ids: togglePosStatus(filterData.status_ids, id), page: null }
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	// Клик по плашке «Кредит» — показать только точки с неоплаченным доверительным платежом
	function toggleCreditFilter() {
		const nextFilterData = { ...filterData, credit_only: !filterData.credit_only, page: null }
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	function handlePaginate(page) {
		paginate(page)
		searchWithFilter({ ...filterData, page })
	}

	async function handleSelectCountry(option) {
		patchFilterData({ 'country_id': option ? option.id : null })
		if (option) getRegions(option.id)
	}

	async function handleSelectRegion(option) {
		patchFilterData({ 'region_id': option ? option.id : null, 'no_region': false })
	}

	function returnClassStatus(status) {
		if (status === 1) {
			return "bg-primary"
		}
		if (status === -1) {
			return "bg-danger"
		}
		if (status === -2) {
			return "bg-secondary"
		}
		if (status === -3) {
			return "bg-danger"
		}
	}

	async function getPosPaymentTypes() {
		const response = await GET('/admin/helper/pos-payment-types')
		if (httpOk(response)) setPosPaymentTypes(response.data)
	}

	async function getUsers() {
		const response = await GET('/admin/helper/users')
		if (httpOk(response)) setUsers(response.data)
	}

	async function getPoses() {
		const response = await GET('/admin/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	async function getPartners() {
		const response = await GET('/admin/helper/partners')
		if (httpOk(response)) {
			setPartners(response.data)
			return response.data
		}
		return []
	}

	async function getCountries() {
		const response = await GET('/helper/countries')
		if (httpOk(response)) setCountries(response.data)
	}

	async function getFilterServices() {
		const response = await GET('/admin/subscription-services', { status: 1 })
		if (httpOk(response)) setFilterServices(response.data.data ?? [])
	}

	/**
	 * Войти в кабинет клиента — то, ради чего поддержка раньше держала мастер-пароль.
	 *
	 * Текущая сессия администратора заменяется сессией клиента (как при переключении
	 * между связанными аккаунтами), поэтому спрашиваем подтверждение: обратно —
	 * только через свой логин.
	 */
	async function loginAsClient(item) {
		if (!item.login) {
			toast.error('У заведения нет владельца')
			return
		}

		// eslint-disable-next-line no-restricted-globals
		if (!window.confirm(`Войти в кабинет «${item.login}»? Текущая сессия админки закроется.`)) {
			return
		}

		const response = await POST('/admin/login-as', { login: item.login }, { loader: true })

		if (httpOk(response)) {
			localStorage.setItem('login', response.data.login.toLowerCase())
			localStorage.setItem('role', response.data.role)
			localStorage.setItem('token', response.data.token)

			store.dispatch(SET_ACCOUNT({ ...response.data, main_user_id: response.data.id }))

			setTimeout(() => {
				window.location.href = '/analytics/dashboard'
			}, 500)
		}
	}

	async function getRegions(country_id) {
		const response = await GET(`/helper/regions/${country_id}`)
		if (httpOk(response)) setRegions(response.data)
	}

	useEffect(() => {
		getPartners()
		getCountries()
		getFilterServices()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const posSortState = posSortStateForIndicator(filterData)
	const statusNote = (selectedItem.status_note ?? '').trim()
	// причина обязательна только при удалении точки
	const isStatusNoteRequired = Number(selectedItem.status) === -3

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="vertical-center">
					<h4>
						{t('poses')} [{data.total}]
					</h4>
				</div>
				<div className="d-flex gap-2">
					<Dropdown>
						<Dropdown.Toggle variant="outline-primary" className="btn-rounded btn-wide">
							Действия
						</Dropdown.Toggle>
						<Dropdown.Menu align="end" className="dropdown-actions">
							<Dropdown.Item onClick={() => setShowModalVersions(true)}>
								<i className="uil-code-branch"></i>
								Версии кассы
							</Dropdown.Item>
							<Dropdown.Item onClick={() => setShowModalFunnel(true)}>
								<i className="uil-chart-line"></i>
								Активные и платящие
							</Dropdown.Item>
							<Dropdown.Item onClick={() => setShowModalSummary(true)}>
								<i className="uil-chart-pie"></i>
								Сводка по оплатам
							</Dropdown.Item>
							{hasPermission('admin_poses_telegram') &&
								<Dropdown.Item onClick={() => setShowModalTelegram(true)}>
									<i className="uil-telegram-alt"></i>
									Telegram-группы
								</Dropdown.Item>
							}
							{hasPermission('admin_poses_delete') &&
								<>
									<Dropdown.Divider />
									<Dropdown.Item className="text-danger"
										title="Перевести отключённые точки текущей выборки в статус «Удален»"
										onClick={() => toggleModalBulkDelete(true)}>
										<i className="uil-trash-alt"></i>
										Удалить отключённые
									</Dropdown.Item>
								</>
							}
						</Dropdown.Menu>
					</Dropdown>
					{hasPermission('admin_poses_create') &&
						<button className="btn-rounded btn btn-primary"
							onClick={() => toggleModalCreateUpdate(true)}>
							{t('create')}
						</button>
					}
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									onSearchChange={(search) => applySearch(search, (nextFilterData) => {
										searchWithFilter(nextFilterData)
									})}>
								</FilterSearch>
							</div>
							<div className="d-flex gap-2">
								<Dropdown autoClose="outside" onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>
									<Dropdown.Menu className="dropdown-filter" onClick={(e) => e.stopPropagation()}>
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('status')}</label>
												<Select
													{...SELECT_PORTAL_PROPS}
													isMulti
													isClearable
													options={statuses}
													value={filterData.status_ids}
													onChange={(options) => setFilterData({ ...filterData, 'status_ids': options ? options : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('partner')}</label>
												{/* Логин рядом с именем: у партнёров бывают одинаковые имена */}
												<Select
													{...SELECT_PORTAL_PROPS}
													isClearable
													options={partners}
													value={partners.find(option => option.id === filterData.partner_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'partner_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name + ' (' + option.login + ')'}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-12">
												<label>Услуга подписки</label>
												{/* Точки, у которых услуга включена (активная привязка) */}
												<Select
													{...SELECT_PORTAL_PROPS}
													isClearable
													options={filterServices}
													value={filterServices.find(option => option.id === filterData.service_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'service_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('countries')}<span className="required-mark">*</span></label>
												<Select
													{...SELECT_PORTAL_PROPS}
													isClearable
													options={countries}
													value={countries.find(option => option.id === filterData.country_id) || ''}
													onChange={(option) => handleSelectCountry(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('regions')}</label>
												<Select
													{...SELECT_PORTAL_PROPS}
													isClearable
													options={regions}
													value={regions.find(option => option.id === filterData.region_id) || ''}
													onChange={(option) => handleSelectRegion(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row mt-2">
											<div className="form-group col-md-12">
												<div className="form-check mb-0">
													<input
														id="pos-filter-tariff-not-zero"
														className="form-check-input"
														type="checkbox"
														checked={!!filterData.tariff_not_zero}
														onChange={(e) => setFilterData({ ...filterData, 'tariff_not_zero': e.target.checked })}
													/>
													<label className="form-check-label" htmlFor="pos-filter-tariff-not-zero">
														{t('poses_only_with_tariff')}
													</label>
												</div>
												<div className="form-check mb-0">
													<input
														id="pos-filter-credit-only"
														className="form-check-input"
														type="checkbox"
														checked={!!filterData.credit_only}
														onChange={(e) => setFilterData({ ...filterData, 'credit_only': e.target.checked })}
													/>
													<label className="form-check-label" htmlFor="pos-filter-credit-only">
														{t('poses_only_credit')}
													</label>
												</div>
												<div className="form-check mb-0">
													<input
														id="pos-filter-no-region"
														className="form-check-input"
														type="checkbox"
														checked={!!filterData.no_region}
														onChange={(e) => setFilterData({ ...filterData, 'no_region': e.target.checked, 'region_id': e.target.checked ? null : filterData.region_id })}
													/>
													<label className="form-check-label" htmlFor="pos-filter-no-region">
														{t('poses_no_region')}
													</label>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => applyFilters((nextFilterData) => {
															searchWithFilter(nextFilterData)
														})}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
								<button className="btn btn-outline-primary btn-wide-2"
									onClick={() => downloadExcel()}>
									<i className="uil uil-file-download-alt"></i>
								</button>
							</div>
							<PosStatusToggles counts={data?.status} statusIds={filterData.status_ids}
								onToggle={toggleStatusFilter}
								creditOn={!!filterData.credit_only} onCreditToggle={toggleCreditFilter} />
						</div>
					</div>

					{filterDataExist && ''}

					<div className="table-responsive" style={{ 'minHeight': '500px' }}>
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'minWidth': '33px' }} className="text-center">ID</th>
									<th style={{ 'width': '10%' }}>{t('login')}</th>
									<th style={{ 'width': '30%' }}>{t('pos')}</th>
									<th style={{ 'width': '10%' }}>{t('region')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('partner')}%</th>
									<th style={{ 'minWidth': '105px' }}>{t('phone')}</th>
									<th
										style={{ 'width': '10%' }}
										className="text-end th-sortable user-select-none"
										onClick={() => handlePosTableSort('tariff')}
										title={t('sort_by')}
									>
										<div className="d-flex align-items-center justify-content-end gap-1">
											<span>{t('tariff')}</span>
											{renderSortIndicator('tariff', posSortState)}
										</div>
									</th>
									<th
										style={{ 'width': '10%' }}
										className="text-end th-sortable user-select-none"
										onClick={() => handlePosTableSort('balance')}
										title={t('sort_by')}
									>
										<div className="d-flex align-items-center justify-content-end gap-1">
											<span>{t('balance')}</span>
											{renderSortIndicator('balance', posSortState)}
										</div>
									</th>
									<th style={{ 'minWidth': '88px' }} className="text-center">{t('date')}</th>
									<th
										style={{ 'minWidth': '88px' }}
										className="text-center th-sortable user-select-none"
										onClick={() => handlePosTableSort('credit')}
										title={t('sort_by')}
									>
										<div className="d-flex align-items-center justify-content-center gap-1">
											<span>{t('credit')}</span>
											{renderSortIndicator('credit', posSortState)}
										</div>
									</th>
									<th
										style={{ 'minWidth': '88px' }}
										className="text-center th-sortable user-select-none"
										onClick={() => handlePosTableSort('version')}
										title={t('sort_by')}
									>
										<div className="d-flex align-items-center justify-content-center gap-1">
											<span>{t('version')}</span>
											{renderSortIndicator('version', posSortState)}
										</div>
									</th>
									<th
										style={{ 'width': '10%' }}
										className="text-center td-ellipsis th-sortable user-select-none"
										title={t('last_cheque')}
										onClick={() => handlePosTableSort('cheque')}
									>
										<div className="d-flex align-items-center justify-content-center gap-1">
											<span className="td-ellipsis">{t('last_cheque')}</span>
											{renderSortIndicator('cheque', posSortState)}
										</div>
									</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('status')}</th>
									<th style={{ 'minWidth': '33px' }} className="text-end"></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="text-center"
											onClick={(e) => {
												e.stopPropagation(); // 🔥 Останавливаем всплытие
												toggleModalTerminal(true, item);
											}}>
											<b>{item.id}</b>
										</td>
										{/* иконка прижата к правому краю ячейки, а не к тексту:
											иначе у длинных и коротких логинов она пляшет по строке */}
										<td className="position-relative" style={{ paddingRight: '26px' }}>
											<span role="button"
												title={copiedLogin === item.login ? 'Скопировано' : 'Нажмите, чтобы скопировать логин'}
												onClick={() => copyLogin(item.login)}>
												{item.login}
											</span>
											{item.has_telegram_chat ?
												<i className="uil-telegram-alt text-primary position-absolute"
													style={{ right: '7px', top: '50%', transform: 'translateY(-50%)' }}
													title="Есть Telegram-группа"></i>
												:
												// группы нет — красная иконка выдаёт ссылку для клиента;
												// без права её всё равно не выписать, поэтому и не показываем
												hasPermission('admin_poses_telegram') &&
												<i className="uil-telegram-alt text-danger position-absolute"
													role="button"
													style={{ right: '7px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
													title="Telegram-группа не подключена — получить ссылку"
													onClick={(e) => {
														e.stopPropagation()
														setTelegramLinkPos(item)
													}}></i>
											}
										</td>
										<td title={item.name}>{item.name}</td>
										<td className="td-ellipsis" title={item.region_name}>{item.region_name}</td>
										<td className="text-end td-ellipsis"
											style={{ cursor: 'pointer' }}
											title={t('partners')}
											onClick={(e) => {
												e.stopPropagation()
												toggleModalPartner(true, item)
											}}>
											{item.total_partner_percentage}
										</td>
										<td>{item.phone}</td>
										<td
											className="text-end text-nowrap cursor"
											style={{ cursor: 'pointer' }}
											title={
												Number(item.services_total) > 0
													? `Абонентка: ${formatMoney(item.tariff)} + услуги: ${formatMoney(item.services_total)}`
													: 'Состав тарифа'
											}
											onClick={() => toggleModalServices(true, item)}
										>
											{formatMoney(item.monthly_total ?? item.tariff)}
										</td>
										<td
											className="text-end text-nowrap cursor"
											style={{ cursor: 'pointer' }}
											title={t('payment')}
											onClick={() => toggleModalPayment(item)}
										>
											{formatMoney(item.balance)}
										</td>
										<td className="text-center">{formatDate(item.created_at)}</td>
										<td
											className="text-center cursor"
											style={{ cursor: 'pointer' }}
											title="Доверительный платеж"
											onClick={() => toggleModalPayment(item, 'credit')}
										>
											{isDateActive(item.billing_free_until) &&
												<div className="text-success fw-semibold" title="Бесплатный период">
													{formatDate(item.billing_free_until)}
												</div>
											}
											{item.trust_granted_to &&
												<div className="text-danger fw-semibold" title="Доверительный доступ">
													{formatDate(item.trust_granted_to)}
												</div>
											}
											{!isDateActive(item.billing_free_until) && !item.trust_granted_to &&
												<span className="text-muted">—</span>
											}
										</td>
										<td className="text-center">{item.desktop_client_version}</td>
										<td
											className="text-center cursor"
											style={{ cursor: 'pointer' }}
											title={t('last_cheque')}
											onClick={() => openChequeStatsModal(item)}
										>
											{formatDate(item.last_cheque_date) || '—'}
										</td>
										<td className={`text-center text-white cursor ${returnClassStatus(item.status)}`}
											onClick={() => hasPermission('admin_poses_status') && toggleModalStatus(true, item)}>
											{item.status === 1 &&
												<span>{t('activated')}</span>
											}
											{item.status === -1 &&
												<span>{t('disconnected')}</span>
											}
											{item.status === -2 &&
												<span>{t('frozen')}</span>
											}
											{item.status === -3 &&
												<span>{t('deleted')}</span>
											}
										</td>
										<td>
											<TableDropdown id={`dropdown-${index}`}>
												{hasPermission('admin_poses_login') &&
													<div className="table-dropdown-item"
														onClick={() => loginAsClient(item)}>
														<i className="uil-signin"></i>
														Войти в кабинет
													</div>
												}
												{hasPermission('admin_poses_payment') &&
													<div className="table-dropdown-item"
														onClick={() => toggleModalPayment(item)}>
														<i className="uil-money-withdraw"></i>
														Оплата
													</div>
												}
												{hasPermission('admin_poses_update') &&
													<div className="table-dropdown-item"
														onClick={() => toggleModalUpdate(item)}>
														<i className="uil-edit-alt"></i>
														{t('edit')}
													</div>
												}
												{hasPermission('admin_poses_partners') &&
													<div className="table-dropdown-item"
														onClick={() => toggleModalPartner(true, item)}>
														<i className="uil-users-alt"></i>
														{t('partners')}
													</div>
												}
												{hasPermission('admin_poses_subscription') &&
													<div className="table-dropdown-item"
														onClick={() => toggleModalServices(true, item)}>
														<i className="uil-bill"></i>
														Доп. услуги
													</div>
												}
												{hasPermission('admin_poses_terminals') &&
													<>
														<div className="table-dropdown-item"
															onClick={() => toggleModalTerminal(true, item)}>
															<i className="uil-desktop"></i>
															{t('terminals')}
														</div>
														<div className="table-dropdown-item"
															onClick={() => openCreateTerminalModal(item)}>
															<i className="uil-plus-circle"></i>
															{t('create_terminal')}
														</div>
														<div className="table-dropdown-item"
															onClick={() => openCreateCashboxModal(item)}>
															<i className="uil-plus-circle"></i>
															{t('create_cashbox')}
														</div>
													</>
												}
												{hasPermission('admin_poses_billing') &&
													<div className="table-dropdown-item"
														onClick={() => toggleModalInfo(item)}>
														<i className="uil-history"></i>
														История оплат
													</div>
												}
												{hasPermission('admin_pos_status_history') &&
													<div className="table-dropdown-item"
														onClick={() => openStatusHistory(item)}>
														<i className="uil-history"></i>
														{t('pos_status_history')}
													</div>
												}
												{hasPermission('admin_poses_payment') &&
													<div className="table-dropdown-item"
														onClick={() => toggleModalInvoice(item)}>
														<i className="uil-arrow-right"></i>
														Выставить счет
													</div>
												}
											</TableDropdown>
										</td>
									</tr>
								))}
								<tr>
									<td></td>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td className="text-end text-nowrap"><b>{formatMoney(data.total_tariff)}</b></td>
									<td className="text-end text-nowrap"><b>{formatMoney(data.total_debt)}</b></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={handlePaginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL CREATE UPDATE*/}
			{modalCreateUpdate &&
				<ModalCreateUpdate
					users={users}
					searchWithFilter={searchWithFilter}
					selectedItem={selectedItem}
					setSelectedItem={setSelectedItem}
					createUpdate={createUpdate}
					modalCreateUpdate={modalCreateUpdate}
					toggleModalCreateUpdate={toggleModalCreateUpdate}
				>
				</ModalCreateUpdate>
			}
			{/* MODAL CREATE UPDATE*/}

			{/* MODAL PARTNER*/}
			<Modal Modal show={modalPartner} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalPartner()}>
				<Modal.Header closeButton>
					<Modal.Title>	{t('edit')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{canManagePartners &&
					<form onSubmit={(e) => createPosPartner(e)} autoComplete="off">
						<div className="d-flex gap-2">
							<div className="form-group w-100">
								<label>{t('partner')}</label>
								<Select
									{...SELECT_PORTAL_PROPS}
									isClearable
									options={partners}
									value={partners.find(option => option.id === selectedItem.partner_id) || ''}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'partner_id': option ? option.id : null })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							<div className="form-group w-100">
								<label>{t('percentage')}</label>
								<input type="number" className="form-control" name="partner_percentage" value={selectedItem.partner_percentage}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'partner_percentage': e.target.value })} />
							</div>

							<div className="form-group">
								{/* Пустой лейбл, чтобы кнопка опустилась вниз */}
								<label className="d-block">&nbsp;</label>
								<button type="submit" className="btn btn-primary w-100">
									{t('add')}
								</button>
							</div>
						</div>
					</form>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'width': '80%' }}>{t('partner')}</th>
									<th style={{ 'width': '20%' }}>{t('percentage')}</th>
									{canManagePartners && <th style={{ 'minWidth': '33px' }}></th>}
								</tr>
							</thead>
							<tbody>
								{selectedItemPartners?.map((item, index) => (
									<tr key={index}>
										<td>
											<Select
												{...SELECT_PORTAL_PROPS}
												isDisabled={!canManagePartners}
												options={partners}
												value={partners.find(option => option.id === item.partner_id) || ''}
												onChange={(option) => handleChangePartner(option)}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</td>
										<td>
											<input type="number" className="form-control" name="partner_percentage"
												disabled={!canManagePartners}
												value={item.partner_percentage}
												onChange={(e) => handleChangePartnerPercentage(e.target.value, index)}
											/>
										</td>
										{canManagePartners &&
										<td className="vertical-middle">
											<div className="d-flex justify-content-center gap-2">
												<div className="table-action-button table-action-primary-button"
													onClick={() => updatePosPartner(item)}>
													<i className="uil uil-check"></i>
												</div>
												<div className="table-action-button table-action-danger-button"
													onClick={() => deletePosPartner(item)}>
													<i className="uil uil-times"></i>
												</div>
											</div>
										</td>
										}
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<button type="button" className="btn btn-outline-warning w-100 mt-3"
						onClick={() => toggleModalPartner()}>
						{t('cancel')}
					</button>
				</Modal.Body>
			</Modal>
			{/* MODAL PARTNER*/}

			{/* MODAL SUBSCRIPTION SERVICES */}
			<Modal show={modalServices} animation={false} centered size="lg"
				dialogClassName="update-modal-width"
				onHide={() => toggleModalServices()}>
				<Modal.Header closeButton>
					<Modal.Title>Тариф — #{selectedItem.id} {selectedItem.name || ''}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive mb-3">
						<table className="table table-bordered table-sm mb-0">
							<thead>
								<tr>
									<th>Состав ежемесячной суммы</th>
									<th className="text-center" style={{ width: '17%' }}>Добавлена</th>
									<th className="text-center" style={{ width: '17%' }}>Посл. списание</th>
									<th className="text-end" style={{ width: '20%' }}>{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Абонентская плата</td>
									<td className="text-center text-nowrap">
										{posBilling?.pos_created_at ? formatDate(posBilling.pos_created_at) : '—'}
									</td>
									<td className="text-center text-nowrap">
										{posBilling?.tariff_last_charged_at ? formatDate(posBilling.tariff_last_charged_at) : '—'}
									</td>
									<td className="text-end text-nowrap">
										{formatMoney(posBilling?.tariff ?? selectedItem.tariff)}
									</td>
								</tr>
								{getActiveBillingServices(selectedItemServices).map((item) => (
										<tr key={`bill-${item.id}`}>
											<td>
												{item.name}
												{item.code ? <small className="text-muted"> ({item.code})</small> : null}
											</td>
											<td className="text-center text-nowrap">
												{item.created_at ? formatDate(item.created_at) : '—'}
											</td>
											<td className="text-center text-nowrap">
												{item.last_charged_at ? formatDate(item.last_charged_at) : '—'}
											</td>
											<td className="text-end text-nowrap">{formatMoney(item.price)}</td>
										</tr>
									))}
								{getActiveBillingServices(selectedItemServices).length === 0 &&
									<tr>
										<td>Доп. услуги</td>
										<td></td>
										<td></td>
										<td className="text-end text-nowrap">{formatMoney(0)}</td>
									</tr>
								}
								<tr>
									<td><b>Итого в месяц</b></td>
									<td></td>
									<td></td>
									<td className="text-end text-nowrap">
										<b>{formatMoney(posBilling?.monthly_total ?? (
											Number(posBilling?.tariff ?? selectedItem.tariff ?? 0)
											+ Number(posBilling?.services_total ?? 0)
										))}</b>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<form onSubmit={createPosService} autoComplete="off">
						<div className="d-flex gap-2">
							<div className="form-group w-100">
								<label>Услуга</label>
								<Select
									{...SELECT_PORTAL_PROPS}
									isClearable
									options={subscriptionServicesCatalog}
									value={subscriptionServicesCatalog.find((option) => option.id === serviceForm.service_id) || null}
									onChange={(option) => setServiceForm({
										service_id: option ? option.id : null,
										price: option ? normalizeServicePrice(option.default_price) : '',
									})}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => `${option.name} (${option.code})`}
									getOptionValue={(option) => option.id}
								/>
							</div>
							<div className="form-group w-100">
								<label>{t('price')}</label>
								<input type="text" className="form-control"
									value={formatMoneyInput(serviceForm.price)}
									onChange={(e) => setServiceForm({
										...serviceForm,
										price: e.target.value.replace(/[^0-9.]/g, ''),
									})} />
								<small className="text-muted">0 = бесплатно для этой точки</small>
							</div>
							<div className="form-group">
								<label className="d-block">&nbsp;</label>
								<button type="submit" className="btn btn-primary w-100">{t('add')}</button>
							</div>
						</div>
					</form>

					<div className="table-responsive">
						<table className="table table-bordered mb-0" style={{ tableLayout: 'fixed' }}>
							<thead>
								<tr>
									<th style={{ width: '34%' }}>Услуга</th>
									<th className="text-end" style={{ width: '16%' }}>{t('price')}</th>
									<th className="text-center" style={{ width: '20%' }}>Статус</th>
									<th className="text-center" style={{ width: '22%' }}>Отсрочка</th>
									<th style={{ width: '8%' }}></th>
								</tr>
							</thead>
							<tbody>
								{selectedItemServices.map((item, index) => (
									<tr key={item.id}>
										<td className="td-ellipsis vertical-middle" title={item.name}>
											{item.name}
										</td>
										{/* Цена и отсрочка правятся прямо в ячейке: серый фон и карандаш вместо рамки инпута */}
										<td className="td-input td-input-editable td-input-fill">
											<div className="td-editable">
												<i className="uil uil-pen td-editable-icon"></i>
												<input type="text" className="form-control text-end"
													autoComplete="off"
													title={t('press_enter_to_save')}
													value={formatMoneyInput(item.price)}
													onChange={(e) => handleChangeServicePrice(
														e.target.value.replace(/[^0-9.]/g, ''),
														index
													)}
													onBlur={() => savePosServicePrice(item)}
													onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur() }} />
											</div>
										</td>
										{/* Статус — заливка ячейки, причина доступа на кассе — в title */}
										<td className={`text-center vertical-middle text-nowrap ${getServiceStatusClass(item)}`}
											title={Number(item.status) === 1 ? getServiceAccessLabel(item) : ''}>
											{Number(item.status) === 1
												? <>
													Активный
													{!item.has_paid_access && item.access_reason !== 'scheduled' &&
														<i className="uil uil-exclamation-circle ms-1"></i>
													}
												</>
												: 'Неактивный'
											}
										</td>
										<td className="td-input td-input-editable td-input-fill">
											<div className="td-editable">
												<i className="uil uil-pen td-editable-icon"></i>
												<DatePicker
													className="form-control text-center"
													dateFormat="dd.MM.yyyy"
													minDate={getTodayDate()}
													maxDate={getServiceDeferralMaxDate()}
													selected={parseServiceAccessUntil(item.access_until)}
													onChange={(date) => deferPosService(item, date)}
													placeholderText="Дата"
													isClearable
													withPortal
													onChangeRaw={(e) => e?.preventDefault?.()}
												/>
											</div>
										</td>
										<td className="vertical-middle">
											<div className="d-flex justify-content-center gap-2">
												<div className="table-action-button table-action-danger-button"
													onClick={() => deletePosService(item)}>
													<i className="uil uil-times"></i>
												</div>
											</div>
										</td>
									</tr>
								))}
								{selectedItemServices.length === 0 &&
									<tr>
										<td colSpan={5} className="text-center text-muted">{t('list_empty')}</td>
									</tr>
								}
							</tbody>
						</table>
					</div>

					<button type="button" className="btn btn-outline-warning w-100 mt-3"
						onClick={() => toggleModalServices()}>
						{t('cancel')}
					</button>
				</Modal.Body>
			</Modal>
			{/* MODAL SUBSCRIPTION SERVICES */}

			{/* MODAL PAYMENT*/}
			<Modal show={modalPayment} animation={false} centered
				dialogClassName="modal-lg"
				onHide={() => setModalPayment(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Оплата — #{selectedItem.id} {selectedItem.name || ''}</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ minHeight: 380, padding: 0 }}>
					<div className="d-flex" style={{ minHeight: 380 }}>
						<div
							className="d-flex flex-column gap-1 p-2"
							style={{
								width: 200,
								flexShrink: 0,
								borderRight: '1px solid var(--dark-border, #dee2e6)',
								background: 'var(--dark-surface-2, #f8f9fa)',
							}}
						>
							{paymentTabs.map((item) => (
								<button
									key={item.id}
									type="button"
									className={`btn btn-sm text-start ${paymentTab === item.id ? 'btn-primary' : 'btn-outline-primary'}`}
									onClick={() => selectPaymentTab(item)}
								>
									{item.name}
								</button>
							))}
						</div>
						<div className="flex-grow-1 d-flex flex-column p-3" style={{ minWidth: 0 }}>
							{(paymentTab === 'payment' || paymentTab === 'partner_bonus' || paymentTab === 'minus' || paymentTab === 'annul' || paymentTab === 'annul_reissue' || paymentTab === 'transfer') &&
								<form
									onSubmit={(e) => payment(e)}
									autoComplete="off"
									className="d-flex flex-column flex-grow-1"
								>
									<div className="flex-grow-1">
										{paymentTab === 'annul_reissue' &&
											<div className="alert alert-warning py-2 mb-3 small">
												Отменит все открытые начисления (все месяцы), обнулит весь минус и выставит
												заново по текущему тарифу/услугам. Бонус агенту — после оплаты.
												Сначала обновите тариф и услуги в карточке точки.
											</div>
										}
										{paymentTab === 'partner_bonus' &&
											<div className="alert alert-info py-2 mb-3 small">
												Списывает сумму с бонусного баланса агента и закрывает долг точки.
												Баланс агента может уйти в минус.
												Не путать с типом оплаты «Партнер бонус» во вкладке «Оплата».
											</div>
										}
										{paymentTab === 'transfer' &&
											<div className="form-group">
												<label>Перевод на точку</label>
												<Select
													{...SELECT_PORTAL_PROPS}
													isClearable
													options={poses}
													value={poses.find(option => option.id === selectedItem.to_pos_id) || ''}
													onChange={(option) => setSelectedItem({ ...selectedItem, 'to_pos_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										}
										{paymentTab === 'partner_bonus' &&
											<div className="form-group">
												<label>Агент</label>
												<Select
													{...SELECT_PORTAL_PROPS}
													isClearable
													options={posBonusPartners}
													value={posBonusPartners.find(option => option.login === selectedItem.partner_login) || ''}
													onChange={(option) => setSelectedItem({
														...selectedItem,
														partner_login: option ? option.login : '',
													})}
													placeholder=""
													noOptionsMessage={() => 'К точке не привязаны агенты'}
													getOptionLabel={(option) => {
														const bal = Number(option.balance)
														const balText = Number.isFinite(bal) ? formatMoney(bal) : '0'
														return `${option.name || option.login} (${option.login}) — ${balText}`
													}}
													getOptionValue={(option) => option.login}
												/>
											</div>
										}
										{paymentTab === 'payment' &&
											<div className="form-group">
												<label>Тип оплаты</label>
												<Select
													{...SELECT_PORTAL_PROPS}
													isClearable
													options={posPaymentTypes}
													value={posPaymentTypes.find(option => option.id === selectedItem.pos_payment_type_id) || ''}
													onChange={(option) => setSelectedItem({ ...selectedItem, 'pos_payment_type_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										}
										{paymentTab !== 'annul' && paymentTab !== 'annul_reissue' &&
											<div className="form-group">
												<label>Сумма</label>
												<input type="text" className="form-control" name="amount"
													value={selectedItem.amount ? formatMoneyInput(selectedItem.amount) : ''}
													onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9.-]/g, '') })}
													required={paymentTab === 'partner_bonus'} />
											</div>
										}
										{(paymentTab === 'payment' || paymentTab === 'annul_reissue') &&
											<>
												<div className="form-check mb-2">
													<input
														id="is_charge_tariff"
														className="form-check-input"
														type="checkbox"
														checked={!!selectedItem.is_charge_tariff}
														onChange={(e) => setSelectedItem({
															...selectedItem,
															is_charge_tariff: e.target.checked,
														})}
													/>
													<label className="form-check-label" htmlFor="is_charge_tariff">
														{paymentTab === 'annul_reissue' ? 'Выставить абонентскую плату' : 'Снять абонентскую плату'}
														{selectedItem.tariff ? ` (${formatMoney(selectedItem.tariff)})` : ''}
													</label>
												</div>
												<div className="form-check mb-2">
													<input
														id="is_charge_services"
														className="form-check-input"
														type="checkbox"
														checked={!!selectedItem.is_charge_services}
														onChange={(e) => setSelectedItem({
															...selectedItem,
															is_charge_services: e.target.checked,
														})}
													/>
													<label className="form-check-label" htmlFor="is_charge_services">
														{paymentTab === 'annul_reissue'
															? 'Выставить доп. услуги'
															: 'Снять доп. услуги (если хватает остатка после абонентки)'}
													</label>
												</div>
											</>
										}
										<div className="form-group">
											<label>{(paymentTab === 'annul' || paymentTab === 'annul_reissue') ? 'Причина' : 'Примечание'}</label>
											<input type="text" className="form-control" name="note" value={selectedItem.note || ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })}
												placeholder={paymentTab === 'annul_reissue' ? 'Смена владельца / новый договор' : ''} />
										</div>
									</div>
									<div className="d-flex w-100 mt-auto pt-3">
										<button type="button" className="btn btn-outline-warning w-100 me-2"
											onClick={() => setModalPayment(false)}>
											{t('cancel')}
										</button>
										<button
											type="submit"
											className="btn btn-primary w-100"
											disabled={paymentTab === 'partner_bonus' && !selectedItem.partner_login}
										>
											{t('save')}
										</button>
									</div>
								</form>
							}

							{paymentTab === 'annul_service' &&
								<div className="d-flex flex-column flex-grow-1">
									<div className="flex-grow-1">
										<div className="alert alert-info py-2 mb-3 small">
											Снимает только выбранное начисление услуги. Абонентка и остальные charge не меняются.
											Если услугу больше не списывать — в тарифе поставьте цену 0 или удалите её.
										</div>
										<div className="form-group">
											<label>Причина</label>
											<input
												type="text"
												className="form-control"
												value={selectedItem.note || ''}
												onChange={(e) => setSelectedItem({ ...selectedItem, note: e.target.value })}
												placeholder="Ошибочное подключение услуги"
											/>
										</div>
										{openServiceCharges.length > 0 ?
											<div className="table-responsive">
												<table className="table table-sm table-bordered mb-0">
													<thead>
														<tr>
															<th>Услуга</th>
															<th className="text-center">Период</th>
															<th className="text-end">Сумма</th>
															<th style={{ width: 40 }}></th>
														</tr>
													</thead>
													<tbody>
														{openServiceCharges.map((charge) => (
															<tr key={charge.id}>
																<td>{charge.service_name || `Услуга #${charge.service_id || charge.id}`}</td>
																<td className="text-center text-nowrap">
																	{charge.billing_cycle_month && charge.billing_cycle_year
																		? `${String(charge.billing_cycle_month).padStart(2, '0')}.${charge.billing_cycle_year}`
																		: '—'}
																</td>
																<td className="text-end text-nowrap">{formatMoney(openChargeAmount(charge))}</td>
																<td className="text-center vertical-middle">
																	<div
																		className="table-action-button table-action-danger-button"
																		title="Аннулировать только это начисление"
																		onClick={() => annulOpenServiceCharge(charge)}
																	>
																		<i className="uil uil-times"></i>
																	</div>
																</td>
															</tr>
														))}
													</tbody>
												</table>
											</div>
											:
											<div className="text-muted text-center py-4">{t('list_empty')}</div>
										}
									</div>
									<div className="d-flex w-100 mt-auto pt-3">
										<button type="button" className="btn btn-outline-warning w-100"
											onClick={() => setModalPayment(false)}>
											{t('cancel')}
										</button>
									</div>
								</div>
							}

							{paymentTab === 'recalc' &&
								<div className="d-flex flex-column flex-grow-1">
									<div className="flex-grow-1">
										<div className="alert alert-info py-2 mb-3 small">
											Для уже оплаченного месяца. Уменьшает начисление (разница — на баланс точки,
											бонус агента сторнируется с разницы), начисляет услуги за текущий месяц с баланса
											и переводит остаток на другую точку клиента. Сначала «Проверить», потом «Провести».
										</div>
										{recalcInfo ?
											<>
												<div className="form-group">
													<label>Уменьшить оплаченное начисление</label>
													{recalcInfo.charges?.length > 0 ?
														<table className="table table-sm table-bordered mb-2">
															<thead>
																<tr>
																	<th style={{ width: 30 }}></th>
																	<th>Начисление</th>
																	<th className="text-end">Сумма</th>
																	<th className="text-end">Оплачено</th>
																</tr>
															</thead>
															<tbody>
																{recalcInfo.charges.map((charge) => (
																	<tr key={charge.id}
																		style={{ cursor: 'pointer' }}
																		onClick={() => changeRecalcForm(recalcForm.charge_id === charge.id
																			? { charge_id: null, new_amount: '' }
																			: { charge_id: charge.id, new_amount: '' })}>
																		<td className="text-center">
																			<input type="checkbox" className="form-check-input"
																				checked={recalcForm.charge_id === charge.id}
																				readOnly />
																		</td>
																		<td>{recalcChargeLabel(charge)}</td>
																		<td className="text-end text-nowrap">{formatMoney(charge.amount_final)}</td>
																		<td className="text-end text-nowrap">{formatMoney(charge.amount_allocated)}</td>
																	</tr>
																))}
															</tbody>
														</table>
														:
														<div className="text-muted small mb-2">Оплаченных начислений за последние месяцы нет</div>
													}
													{recalcInfo.open_charges?.length > 0 &&
														<div className="text-muted small mb-2">
															{recalcInfo.open_charges.map((charge) => (
																<div key={charge.id}>
																	{recalcChargeLabel(charge)} — {formatMoney(charge.amount_final)}, не оплачено
																</div>
															))}
															Неоплаченное здесь не пересчитывается: абонентку — «Аннул. и выставить», услугу — «Аннулировать услугу».
														</div>
													}
													{recalcForm.charge_id &&
														<input type="text" className="form-control" placeholder="Новая сумма начисления"
															value={recalcForm.new_amount !== '' ? formatMoneyInput(recalcForm.new_amount) : ''}
															onChange={(e) => changeRecalcForm({ new_amount: e.target.value.replace(/[^0-9.]/g, '') })} />
													}
												</div>
												<div className="form-group">
													<label>Начислить услуги за текущий месяц</label>
													{recalcInfo.services?.length > 0 ?
														recalcInfo.services.map((service) => (
															<div className="form-check" key={service.service_id}>
																<input id={`recalc_service_${service.service_id}`}
																	className="form-check-input"
																	type="checkbox"
																	disabled={service.is_charged_this_month}
																	checked={recalcForm.service_ids.includes(service.service_id)}
																	onChange={() => toggleRecalcService(service.service_id)} />
																<label className="form-check-label" htmlFor={`recalc_service_${service.service_id}`}>
																	{service.name} — {formatMoney(service.price)}
																	{service.is_charged_this_month
																		? ' (уже начислена)'
																		: (service.started_at ? ` (подключена с ${formatDate(service.started_at)})` : '')}
																</label>
															</div>
														))
														:
														<div className="text-muted small">Платных услуг не подключено</div>
													}
												</div>
												<div className="form-group">
													<label>Перевести с баланса на другую точку клиента</label>
													<div className="d-flex gap-2">
														<div className="flex-grow-1">
															<Select
																{...SELECT_PORTAL_PROPS}
																isClearable
																options={recalcInfo.siblings || []}
																value={(recalcInfo.siblings || []).find((option) => option.id === recalcForm.transfer_to_pos_id) || ''}
																onChange={(option) => changeRecalcForm({ transfer_to_pos_id: option ? option.id : null })}
																placeholder=""
																noOptionsMessage={() => 'У клиента нет других точек'}
																getOptionLabel={(option) => `#${option.id} ${option.name} — ${formatMoney(option.balance)}`}
																getOptionValue={(option) => option.id}
															/>
														</div>
														<input type="text" className="form-control" style={{ width: 160 }} placeholder="Сумма"
															disabled={!recalcForm.transfer_to_pos_id}
															value={recalcForm.transfer_amount !== '' ? formatMoneyInput(recalcForm.transfer_amount) : ''}
															onChange={(e) => changeRecalcForm({ transfer_amount: e.target.value.replace(/[^0-9.]/g, '') })} />
													</div>
												</div>
												<div className="form-group">
													<label>Причина</label>
													<input type="text" className="form-control"
														value={recalcForm.reason}
														onChange={(e) => changeRecalcForm({ reason: e.target.value })}
														placeholder="Договор: тариф 300 000 + ассистент 100 000" />
												</div>
												{recalcPreview &&
													<div className="border rounded p-2 small">
														<div className="fw-bold mb-1">Что изменится</div>
														<table className="table table-sm table-bordered mb-2">
															<thead>
																<tr>
																	<th>Точка</th>
																	<th className="text-end">Баланс до</th>
																	<th className="text-end">Баланс после</th>
																</tr>
															</thead>
															<tbody>
																{(recalcPreview.poses || []).map((row) => (
																	<tr key={row.id}>
																		<td>#{row.id} {row.name}</td>
																		<td className="text-end">{formatMoney(row.balance_before)}</td>
																		<td className="text-end">{formatMoney(row.balance_after)}</td>
																	</tr>
																))}
															</tbody>
														</table>
														{recalcPreview.bonuses?.length > 0 ?
															<table className="table table-sm table-bordered mb-0">
																<thead>
																	<tr>
																		<th>Агент</th>
																		<th>Операция</th>
																		<th className="text-end">База</th>
																		<th className="text-end">Бонус</th>
																	</tr>
																</thead>
																<tbody>
																	{recalcPreview.bonuses.map((row, index) => (
																		<tr key={index}>
																			<td>{row.login} (#{row.pos_id})</td>
																			<td>{row.operation_name} {Number(row.partner_percentage) ? `${Number(row.partner_percentage)}%` : ''}</td>
																			<td className="text-end">{formatMoney(row.amount)}</td>
																			<td className={`text-end ${Number(row.partner_amount) < 0 ? 'text-danger' : 'text-success'}`}>
																				{formatMoney(row.partner_amount)}
																			</td>
																		</tr>
																	))}
																	{recalcBonusTotals(recalcPreview.bonuses).map(([login, total]) => (
																		<tr key={`total_${login}`} className="fw-bold">
																			<td colSpan={3}>Итого {login}</td>
																			<td className="text-end">{formatMoney(total)}</td>
																		</tr>
																	))}
																</tbody>
															</table>
															:
															<div className="text-muted">Бонусы агентов не меняются</div>
														}
													</div>
												}
											</>
											:
											<div className="text-muted text-center py-4">{t('list_empty')}</div>
										}
									</div>
									<div className="d-flex w-100 mt-auto pt-3 gap-2">
										<button type="button" className="btn btn-outline-warning w-100"
											onClick={() => setModalPayment(false)}>
											{t('cancel')}
										</button>
										<button type="button" className="btn btn-outline-primary w-100"
											disabled={!recalcInfo || String(recalcForm.reason).trim().length < 3}
											onClick={previewRecalc}>
											Проверить
										</button>
										<button type="button" className="btn btn-primary w-100"
											disabled={!recalcPreview}
											onClick={applyRecalc}>
											Провести
										</button>
									</div>
								</div>
							}

							{paymentTab === 'free' &&
								<form
									onSubmit={saveFreeUntil}
									autoComplete="off"
									className="d-flex flex-column flex-grow-1"
								>
									<div className="flex-grow-1">
										{freeUntilForm.billing_free_until &&
											<div className="alert alert-success py-2 mb-3 small">
												Сейчас бесплатно до: <b>{formatDate(freeUntilForm.billing_free_until)}</b>
											</div>
										}
										<div className="form-group">
											<label>Бесплатно до (включительно)</label>
											<div className="calendar-input">
												<DatePicker
													className="form-control"
													dateFormat="dd.MM.yyyy"
													minDate={getFreeUntilMinDate()}
													maxDate={getFreeUntilMaxDate()}
													selected={freeUntilForm.billing_free_until
														? new Date(freeUntilForm.billing_free_until)
														: null}
													onChange={(date) => {
														setFreeUntilForm({
															...freeUntilForm,
															billing_free_until: date
																? formatDate(date, 'yyyy-MM-dd')
																: '',
														})
													}}
													placeholderText="ДД.ММ.ГГГГ"
													withPortal
													required
												/>
												<i className="uil uil-calendar-alt"></i>
											</div>
										</div>
										<div className="form-group">
											<label>Причина (увидит клиент в истории)</label>
											<input
												type="text"
												className="form-control"
												value={freeUntilForm.reason || ''}
												onChange={(e) => setFreeUntilForm({ ...freeUntilForm, reason: e.target.value })}
												placeholder="Переход с другой программы"
											/>
										</div>
										<div className="text-muted small mb-2">
											Прошлые даты недоступны, максимум {FREE_UNTIL_MAX_MONTHS} месяца вперёд.
										</div>
									</div>
									<div className="d-flex w-100 mt-auto pt-3 gap-2">
										<button type="button" className="btn btn-outline-warning w-100"
											onClick={() => setModalPayment(false)}>
											{t('cancel')}
										</button>
										<button type="button" className="btn btn-outline-danger w-100"
											onClick={clearFreeUntil}
											disabled={!freeUntilForm.billing_free_until}>
											Снять
										</button>
										<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
									</div>
								</form>
							}

							{paymentTab === 'credit' &&
								<form
									onSubmit={saveCredit}
									autoComplete="off"
									className="d-flex flex-column flex-grow-1"
								>
									<div className="flex-grow-1">
										<div className="form-group">
											<label>Срок (дней)</label>
											<input
												type="number"
												className="form-control"
												min={1}
												max={TRUST_GRANT_MAX_DAYS}
												value={creditForm.days}
												onChange={(e) => {
													const raw = e.target.value.replace(/[^0-9]/g, '')
													const days = raw === '' ? '' : Math.min(TRUST_GRANT_MAX_DAYS, parseInt(raw, 10) || 1)
													setCreditForm({ ...creditForm, days })
												}}
												required
											/>
										</div>
										<div className="form-group">
											<label>До даты (помощник)</label>
											<div className="calendar-input">
												<DatePicker
													className="form-control"
													dateFormat="dd.MM.yyyy"
													minDate={getTrustMinDate()}
													maxDate={getTrustMaxDate()}
													selected={creditForm.days ? dateFromDays(creditForm.days) : null}
													onChange={(date) => {
														if (!date) return
														setCreditForm({
															...creditForm,
															days: daysFromBase(date),
														})
													}}
													placeholderText="Выберите дату"
													withPortal
												/>
												<i className="uil uil-calendar-alt"></i>
											</div>
										</div>
										<div className="form-group">
											<label>Примечание</label>
											<input
												type="text"
												className="form-control"
												value={creditForm.reason || ''}
												onChange={(e) => setCreditForm({ ...creditForm, reason: e.target.value })}
												placeholder="Доверительный платеж"
											/>
										</div>
										<div className="text-muted small mb-2">
											Grant доступа (по умолчанию 1 день, макс. {TRUST_GRANT_MAX_DAYS}).
											Датапикер только подставляет дни. Если уже активен — срок продлевается.
											Списания абонентки не отменяются.
											Активным услугам с ценой &gt; 0 ставится та же дата отсрочки.
										</div>
										{selectedItem.trust_granted_to &&
											<div className="text-muted small">
												Текущий доверительный доступ до: {formatDate(selectedItem.trust_granted_to)}
											</div>
										}
									</div>
									<div className="d-flex w-100 mt-auto pt-3">
										<button type="button" className="btn btn-outline-warning w-100 me-2"
											onClick={() => setModalPayment(false)}>
											{t('cancel')}
										</button>
										<button type="submit" className="btn btn-primary w-100">Включить</button>
									</div>
								</form>
							}
						</div>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT*/}

			{/* MODAL INVOICE*/}
			<Modal show={modalInvoice} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setModalInvoice(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Выставить счет</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createInvoice(e)} autoComplete="off">
						<div className="form-group">
							<label>Сумма</label>
							<input type="text" className="form-control" name="amount"
								value={selectedItem.amount ? formatMoneyInput(selectedItem.amount) : ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9]/g, '') })} />
						</div>
						<div className="input-group mb-2">
							<span className="input-group-text">998</span>
							<input type="number" className="form-control"
								name="invoice_phone"
								placeholder={t('phone')}
								value={selectedItem.invoice_phone ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'invoice_phone': e.target.value.replace(/[^0-9]/g, '') })}
							/>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => setSelectedItem(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL INVOICE*/}

			{/* MODAL CHANGE STATUS*/}
			<Modal show={modalStatus} animation={false} centered size="sm"
				dialogClassName="update-modal-width"
				onHide={() => toggleModalStatus(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Статус</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => handleChangeStatus(e)} autoComplete="off">
						<div className="d-flex flex-column gap-3">
							<div className="form-check">
								<input id="status1" className="form-check-input" type="radio" name="status"
									checked={selectedItem.status === 1 ? true : false}
									onChange={(e) => {
										if (e.target.checked) {
											setSelectedItem({ ...selectedItem, 'status': 1 })
										}
									}}
								/>
								<label className="form-check-label" htmlFor="status1">
									Активировать
								</label>
							</div>
							<div className="form-check">
								<input id="status-1" className="form-check-input" type="radio" name="status"
									checked={selectedItem.status === -1 ? true : false}
									onChange={(e) => {
										if (e.target.checked) {
											setSelectedItem({ ...selectedItem, 'status': -1 })
										}
									}}
								/>
								<label className="form-check-label" htmlFor="status-1">
									Заблокирован за неуплату
								</label>
							</div>
							<div className="form-check">
								<input id="status-3" className="form-check-input" type="radio" name="status"
									checked={selectedItem.status === -3 ? true : false}
									onChange={(e) => {
										if (e.target.checked) {
											setSelectedItem({ ...selectedItem, 'status': -3 })
											// причина обязательна — сразу ставим курсор в неё
											statusNoteRef.current?.focus()
										}
									}}
								/>
								<label className="form-check-label" htmlFor="status-3">
									Удален
								</label>
							</div>
						</div>

						<div className="form-group mt-3">
							<label>
								{t('note')}
								{isStatusNoteRequired && <span className="required-mark">*</span>}
							</label>
							<textarea
								ref={statusNoteRef}
								className="form-control"
								rows="3"
								value={selectedItem.status_note ?? ''}
								placeholder={isStatusNoteRequired ? t('pos_delete_reason') : t('status_change_reason')}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'status_note': e.target.value })}
							/>
							{isStatusNoteRequired && !statusNote &&
								<div className="text-danger mt-1">{t('pos_delete_reason_required')}</div>
							}
						</div>

						<div className="d-flex w-100 mt-3">
							<button type="submit" className="btn btn-primary w-100"
								disabled={isStatusNoteRequired && !statusNote}>
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CHANGE STATUS*/}

			{/* MODAL BULK DELETE */}
			<Modal show={modalBulkDelete} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalBulkDelete(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Удаление отключённых точек</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => handleBulkDelete(e)} autoComplete="off">
						{bulkDelete.total === null &&
							<div className="text-secondary">Считаем, сколько точек попадёт под удаление…</div>
						}

						{bulkDelete.total === 0 &&
							<div className="text-secondary">
								Под текущие фильтры не попало ни одной отключённой точки
							</div>
						}

						{bulkDelete.total > 0 &&
							<>
								<div className="alert alert-danger mb-3">
									Будет удалено точек: <b>{bulkDelete.total}</b>
									<div className="mt-1" style={{ fontSize: '12px' }}>
										Берём только точки со статусом «Отключен», попавшие под текущие фильтры
										списка (поиск, регион, тариф). Активные точки не затрагиваются.
										Каждая смена статуса попадёт в историю статусов с указанной причиной.
									</div>
								</div>

								<div className="form-group">
									<label>
										Причина
										<span className="required-mark">*</span>
									</label>
									<textarea className="form-control" rows="3" autoFocus
										value={bulkDelete.note}
										placeholder="Например: не платят более полугода, связи нет"
										onChange={(e) => setBulkDelete({ ...bulkDelete, 'note': e.target.value })}
									/>
									{!bulkDelete.note.trim() &&
										<div className="text-danger mt-1">Без причины удалить нельзя</div>
									}
								</div>
							</>
						}

						<div className="d-flex w-100 mt-3 gap-2">
							<button type="button" className="btn btn-warning w-100"
								onClick={() => toggleModalBulkDelete(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-danger w-100"
								disabled={!bulkDelete.total || !bulkDelete.note.trim()}>
								Удалить {bulkDelete.total > 0 ? bulkDelete.total : ''}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL BULK DELETE */}

			{/* MODAL PAYMENT HISTORY*/}
			<Modal show={modalInfo} animation={false} centered
				size="xl"
				dialogClassName="modal-dialog-scrollable"
				onHide={() => setModalInfo(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						История
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th className="text-nowrap">{t('date')}</th>
									<th style={{ minWidth: '220px' }}>{t('note')}</th>
									<th className="text-nowrap text-center">{t('payment_type')}</th>
									<th className="text-nowrap text-center">Операция</th>
									<th className="text-nowrap text-center">{t('status')}</th>
									<th className="text-nowrap">Кто провёл</th>
									<th className="text-nowrap text-end">{t('amount')}</th>
									<th className="text-nowrap text-center" style={{ width: '40px' }}></th>
								</tr>
							</thead>
							<tbody>
								{payments?.map((item, index) => (
									<tr key={index}>
										<td className="text-nowrap">{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
										<td title={item.note}>{item.note}</td>
										<td className="text-center text-nowrap">
											{canChangePaymentType(item) ?
												<span className="text-primary"
													style={{ textDecoration: 'underline', cursor: 'pointer' }}
													title="Изменить тип оплаты"
													onClick={() => openPaymentTypeModal(item)}>
													{getPaymentTypeLabel(item)}
												</span>
												:
												getPaymentTypeLabel(item)
											}
										</td>
										<td className={`text-center text-nowrap ${item.operation_kind === 'annul' || item.operation_kind === 'balance_minus' || item.transaction_type === 'minus' ? 'text-danger' : ''}`}>
											{getOperationKindLabel(item)}
										</td>
										<td className="text-center">
											{item.payment_type === 'reverse' ? (
												<span className="text-danger">Сторно</span>
											) : item.status === 1 ? (
												<span className="text-success">Успешно</span>
											) : item.status === -2 && item.transaction_type !== 'minus' ? (
												<span className="text-danger">Отменена</span>
											) : item.status === -2 ? (
												<span className="text-danger">Списание</span>
											) : item.status === -3 ? (
												<span className="text-danger">Перевод</span>
											) : null}
										</td>
										<td className="text-nowrap">
											{item.created_by ? (
												<span title={item.created_by}>
													{item.created_by_name || item.created_by}
													{item.created_by_name &&
														<span className="text-muted ms-1">({item.created_by})</span>
													}
												</span>
											) : (
												<span className="text-muted">{getPaymentAuthorFallback(item)}</span>
											)}
										</td>
										<td className={`text-nowrap text-end ${item.transaction_type === 'minus' ? 'text-danger' : ''}`}>
											{formatMoney(item.amount)}
										</td>
										<td className="text-center">
											{canReversePayment(item, index) &&
												<button
													type="button"
													className="btn btn-sm btn-outline-danger border-0"
													title="Отменить оплату, списания и бонус агенту"
													onClick={() => openReversePaymentModal(item)}>
													<i className="uil uil-trash-alt"></i>
												</button>
											}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT HISTORY*/}

			{/* MODAL CHANGE PAYMENT TYPE */}
			{/* Открывается поверх истории, поэтому фокус не перехватываем — как у сторно */}
			<Modal show={modalPaymentType} animation={false} centered
				dialogClassName="update-modal-width"
				enforceFocus={false}
				restoreFocus={false}
				onHide={() => setModalPaymentType(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Тип оплаты</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="mb-2">
						<div><b>Оплата от:</b> {formatDate(selectedPaymentRow.created_at, 'dd.MM.yyyy HH:mm')}</div>
						<div><b>Сумма:</b> {formatMoney(selectedPaymentRow.amount)}</div>
					</div>
					<div className="form-group">
						<label>Тип</label>
						<Select
							options={allPaymentTypes}
							value={allPaymentTypes.find(option => option.id === selectedPaymentRow.pos_payment_type_id) || null}
							onChange={(option) => setSelectedPaymentRow({
								...selectedPaymentRow,
								pos_payment_type_id: option ? option.id : null,
							})}
							placeholder=""
							noOptionsMessage={() => t('list_empty')}
							getOptionLabel={(option) => option.name}
							getOptionValue={(option) => option.id}
							{...SELECT_PORTAL_PROPS}
						/>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="d-flex gap-2 w-100 justify-content-end">
						<button className="btn btn-warning"
							onClick={() => setModalPaymentType(false)}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary"
							disabled={!selectedPaymentRow.pos_payment_type_id}
							onClick={savePaymentType}>
							{t('save')}
						</button>
					</div>
				</Modal.Footer>
			</Modal>
			{/* MODAL CHANGE PAYMENT TYPE */}

			{/* MODAL REVERSE PAYMENT*/}
			<Modal show={modalReversePayment} animation={false} centered
				dialogClassName="update-modal-width"
				enforceFocus={false}
				restoreFocus={false}
				onHide={() => closeReversePaymentModal(true)}>
				<Modal.Header closeButton>
					<Modal.Title>
						Отмена оплаты
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => reverseLastPayment(e)} autoComplete="off">
						<div className="alert alert-warning py-2 small">
							Отменит оплату, связанные списания абонентки/услуг и бонус агенту.
							Затем введите оплату на правильную точку.
						</div>
						<div className="form-group">
							<label>{t('amount')}</label>
							<input type="text" className="form-control" readOnly
								value={formatMoney(reversePaymentItem.amount)} />
						</div>
						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note" required
								value={reverseNote}
								onChange={(e) => setReverseNote(e.target.value)}
								placeholder="Ошибка: оплата должна была на POS #…" />
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-secondary w-100 me-2"
								onClick={() => closeReversePaymentModal(true)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-danger w-100">
								Отменить
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL REVERSE PAYMENT*/}

			{/* MODAL TERMINAL CASHIERS*/}
			<Modal show={modalTerminal} animation={false} centered scrollable
				onHide={() => toggleModalTerminal()}>
				<Modal.Header closeButton>
					<Modal.Title>
						Терминал
					</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ height: '500px' }}>
					<div className="table-responsive mb-2">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th className="text-nowrap" style={{ 'width': '50%' }}>{t('name2')}</th>
									<th className="text-nowrap" style={{ 'width': '25%' }}>{t('login')}</th>
									<th className="text-nowrap" style={{ 'width': '25%' }}>{t('password')}</th>
									{hasPermission('admin_poses_terminals') &&
										<th style={{ 'width': '40px' }}></th>
									}
								</tr>
							</thead>
							<tbody>
								{terminals?.map((item, index) => (
									<tr key={index}>
										<td className="td-ellipsis">{item.name}</td>
										<td className="td-ellipsis">{item.terminal_login}</td>
										<td className="td-ellipsis">{item.password}</td>
										{hasPermission('admin_poses_terminals') &&
											<td className="text-center">
												<button type="button" className="btn btn-sm btn-outline-danger py-0 px-1"
													disabled={terminals.length <= 1}
													title={terminals.length <= 1 ? 'Последний терминал удалить нельзя' : 'Удалить терминал'}
													onClick={() => deleteTerminal(item)}>
													<i className="uil-trash-alt"></i>
												</button>
											</td>
										}
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th className="text-nowrap" style={{ 'width': '35%' }}>{t('name2')}</th>
									<th className="text-nowrap" style={{ 'width': '25%' }}>{t('role')}</th>
									<th className="text-nowrap" style={{ 'width': '20%' }}>{t('pin_code')}</th>
									<th className="text-nowrap" style={{ 'width': '20%' }}>{t('card_number')}</th>
								</tr>
							</thead>
							<tbody>
								{cashiers?.map((item, index) => (
									<tr key={index}>
										<td className="td-ellipsis">
											<span role="button"
												title={item.login ? `Нажмите, чтобы скопировать логин ${item.login}` : 'У сотрудника нет логина'}
												onClick={() => item.login && copyLogin(item.login)}>
												{item.name}
											</span>
										</td>
										<td className="td-ellipsis">{item.role_name}</td>
										<td className="td-ellipsis">{item.pin_code}</td>
										<td className="td-ellipsis">{item.card_number}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL TERMINAL CASHIERS*/}

			{/* MODAL CREATE TERMINAL */}
			<Modal show={modalCreateTerminal} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setModalCreateTerminal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('create_terminal')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createTerminal} autoComplete="off">
						<div className="form-group">
							<label>{t('pos')}</label>
							<input type="text" className="form-control" value={selectedPosItem.name ?? ''} disabled />
						</div>
						<div className="form-group">
							<label>{t('name2')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								autoFocus
								value={createTerminalItem.name ?? ''}
								onChange={(e) => setCreateTerminalItem({ ...createTerminalItem, name: e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('password')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="password"
								value={createTerminalItem.password ?? ''}
								onChange={(e) => setCreateTerminalItem({ ...createTerminalItem, password: e.target.value })} />
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => setModalCreateTerminal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CREATE TERMINAL */}

			{/* MODAL CREATE CASHBOX */}
			<Modal show={modalCreateCashbox} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setModalCreateCashbox(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('create_cashbox')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createCashbox} autoComplete="off">
						<div className="form-group">
							<label>{t('pos')}</label>
							<input type="text" className="form-control" value={selectedPosItem.name ?? ''} disabled />
						</div>
						<div className="form-group">
							<label>{t('cashbox_name')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								autoFocus
								value={createCashboxItem.name ?? ''}
								onChange={(e) => setCreateCashboxItem({ ...createCashboxItem, name: e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('automatic accrual')}</label>
							<div className="d-flex gap-3">
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_auto: true })}
										style={{ backgroundColor: createCashboxItem.is_auto ? 'black' : '' }}>
									</div>
									<span onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_auto: true })}>
										{t('yes')}
									</span>
								</div>
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_auto: false })}
										style={{ backgroundColor: !createCashboxItem.is_auto ? 'black' : '' }}>
									</div>
									<span onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_auto: false })}>
										{t('no')}
									</span>
								</div>
							</div>
						</div>
						<div className="form-group">
							<label>{t('default')}</label>
							<div className="d-flex gap-3">
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_default: true })}
										style={{ backgroundColor: createCashboxItem.is_default ? 'black' : '' }}>
									</div>
									<span onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_default: true })}>
										{t('yes')}
									</span>
								</div>
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_default: false })}
										style={{ backgroundColor: !createCashboxItem.is_default ? 'black' : '' }}>
									</div>
									<span onClick={() => setCreateCashboxItem({ ...createCashboxItem, is_default: false })}>
										{t('no')}
									</span>
								</div>
							</div>
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => setModalCreateCashbox(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CREATE CASHBOX */}
			<ModalPosChequeStats
				show={modalChequeStats}
				onHide={() => setModalChequeStats(false)}
				posItem={chequeStatsPos}
				apiBase="/admin/pos"
			/>
			<ModalPosTelegramStats
				show={showModalTelegram}
				onHide={() => setShowModalTelegram(false)}
			/>
			<ModalPosTelegramLink
				show={!!telegramLinkPos}
				onHide={() => setTelegramLinkPos(null)}
				posItem={telegramLinkPos}
				url="/admin/pos-telegram-link"
			/>
			<ModalPosVersions
				show={showModalVersions}
				onHide={() => setShowModalVersions(false)}
				filterData={filterData}
			/>
			<ModalPosActivityFunnel
				show={showModalFunnel}
				onHide={() => setShowModalFunnel(false)}
			/>
			<ModalPosStatusSummary
				show={showModalSummary}
				onHide={() => setShowModalSummary(false)}
			/>
		</>
	)
}

export default Index